'use strict';

var configService = require('vimmi-web-utils/cjs/configService');
var eventEmitter = require('vimmi-web-utils/cjs/eventEmitter');
var AMSContentType = require('vimmi-web-utils/cjs/ams/contentType');
var localStore = require('vimmi-web-utils/cjs/localStore');
var fetchAMS = require('vimmi-web-utils/cjs/ams/fetchAMS');
var generateHeaders = require('vimmi-web-utils/cjs/ams/generateHeaders');
var appError = require('vimmi-web-utils/cjs/errors/appError');
var errorCodes = require('vimmi-web-utils/cjs/errors/errorCodes');
var localCache = require('vimmi-web-utils/cjs/localCache');
var sessionCache = require('vimmi-web-utils/cjs/sessionCache');
var getCurrentProtocol = require('vimmi-web-utils/cjs/getCurrentProtocol');
var doFetch = require('vimmi-web-utils/cjs/doFetch');
var getUrlCacheIndex = require('vimmi-web-utils/cjs/getUrlCacheIndex');
var formatPath = require('vimmi-web-utils/cjs/ams/formatPath');
var normDomain = require('vimmi-web-utils/cjs/normDomain');
var normalizeLang = require('vimmi-web-utils/cjs/normalizeLang');
var getDeviceInfo = require('vimmi-web-utils/cjs/ams/getDeviceInfo');
var getApiKey = require('vimmi-web-utils/cjs/ams/getApiKey');
var secondLocation = require('vimmi-web-utils/cjs/secondLocation');
var thirdLocation = require('vimmi-web-utils/cjs/thirdLocation');
var StyledLogger = require('vimmi-web-utils/cjs/logger');
var makeHash = require('vimmi-web-utils/cjs/makeHash');
var formatAISError = require('vimmi-web-utils/cjs/errors/formatAISError');
var toCurrentProtocol = require('vimmi-web-utils/cjs/toCurrentProtocol');
require('vimmi-web-utils/cjs/errors/AISErrorCodes');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var AMSContentType__default = /*#__PURE__*/_interopDefaultLegacy(AMSContentType);
var StyledLogger__default = /*#__PURE__*/_interopDefaultLegacy(StyledLogger);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.
Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.
THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

var Config = new configService.ConfigService();

function getAccessData(sid, privateId) {
    if (sid === void 0) { sid = null; }
    if (privateId === void 0) { privateId = null; }
    return {
        customer: Config.get('appInfo.customer'),
        sid: sid !== null ? sid : Config.get('user.sid'),
        dat: Config.get('user.dat'),
        privateId: privateId !== null ? privateId : Config.get('user.privateId'),
        device_id: Config.get('authInfo.device_id'),
        public_app_key: Config.get('authInfo.public_app_key'),
        'Api-Version': Config.get('appInfo.Api-Version'),
        device_key: Config.get('appInfo.device_key'),
        version: Config.get('appInfo.app_version'),
        language: Config.get('appInfo.language'),
        platform: Config.get('platform'),
        backend: Config.get('backend'),
        deviceRestrictions: Config.get('deviceRestrictions')
    };
}
function updateAMSData(amsData) {
    if (amsData) {
        Config.set(amsData);
    }
    localStore.localStore.set('amsData', {
        user: Config.get('user'),
        products: Config.get('products'),
        offers: Config.get('offers'),
        commands: Config.get('commands'),
        concurrency: Config.get('concurrency'),
        buh: Config.get('buh'),
        fbq: Config.get('fbq'),
        gtm: Config.get('gtm'),
        customer: Config.get('customer'),
        extraData: Config.get('extraData'),
        stock: Config.get('stock')
    });
    return true;
}
function getTimestamp(date, time, timeZoneOffset) {
    if (timeZoneOffset === void 0) { timeZoneOffset = 0; }
    var _d = date.split('-');
    var _t = time.split(':');
    return Date.UTC(+_d[0], (+_d[1]) - 1, +_d[2], +_t[0], +_t[1], +_t[2]) - timeZoneOffset;
}
function formatProducts(products) {
    var result = {};
    var keys = Object.keys(products || {});
    if (keys.length) {
        keys.forEach(function (key) {
            var item = products[key];
            if (item && item.expired_at) {
                var _a = item.expired_at.split(' '), date = _a[0], time = _a[1];
                var expiredTimeStamp = getTimestamp(date, time);
                if (expiredTimeStamp > Date.now()) {
                    result[key] = item;
                }
            }
            else {
                result[key] = item;
            }
        });
    }
    return result;
}

var Commands = /** @class */ (function () {
    function Commands(client) {
        this.client = client;
        this.$logger = null;
        this.commandsWatcherId = null;
        this.commandsCheckTime = null;
        this.errorsCorrection = 0;
        this.syncCallbacks = [];
        this.syncState = {
            // cached: false,
            timeoutId: null,
            failedTime: null,
            failedTimes: 0,
            req: null
        };
        this.$logger = this.client.$logger.cl('Commands', false);
        this.commandsConf = Config.get('commands');
        var scope = this;
        // @ts-ignore
        window.forceSync = function () {
            var cacheIndex = scope.syncCacheIndex();
            localCache.localCache.expire(cacheIndex);
            scope.customSync({ force: true });
        };
        if (Config.get('checkPageRefreshBeforeSync')) {
            window.addEventListener('beforeunload', function () {
                localStore.localStore.set('before_unload', Date.now() / 1000);
            });
            window.addEventListener('unload', function () {
                localStore.localStore.set('before_unload', Date.now() / 1000);
            });
        }
    }
    Commands.prototype.initWatcher = function (cache_time) {
        if (cache_time === void 0) { cache_time = 1; }
        this.setUpCommandsWatcher();
        this.setUpSyncWatcher(cache_time);
    };
    Commands.prototype.customSync = function (options) {
        var _a, _b;
        if (options === void 0) { options = null; }
        return __awaiter(this, void 0, void 0, function () {
            var cacheIndex, buTs, useForce;
            var _this = this;
            return __generator(this, function (_c) {
                if (!(options === null || options === void 0 ? void 0 : options.afterLogin) && !(options === null || options === void 0 ? void 0 : options.force) && this.syncState.req) { // cache sync requests
                    return [2 /*return*/, new Promise(function (resolve, reject) {
                            _this.syncCallbacks.push({ resolve: resolve, reject: reject });
                        })];
                }
                else if (!(options === null || options === void 0 ? void 0 : options.afterLogin) && !(options === null || options === void 0 ? void 0 : options.force) && this.syncState.failedTime && (Date.now() - this.syncState.failedTime) < 60 * 1000) { // if sync failed
                    throw new appError.AppError(errorCodes.ErrorCodes.AMS_ERR, 'Backend doesn\'t respond', '');
                }
                if (this.client.account.logoutStart) {
                    return [2 /*return*/, null];
                }
                cacheIndex = this.syncCacheIndex();
                if ((options === null || options === void 0 ? void 0 : options.afterLogin) && !(options === null || options === void 0 ? void 0 : options.force)) {
                    if ((_a = options === null || options === void 0 ? void 0 : options.op) === null || _a === void 0 ? void 0 : _a.cache_time) {
                        localCache.localCache.set(cacheIndex, { op: (options === null || options === void 0 ? void 0 : options.op) || {} }, (_b = options === null || options === void 0 ? void 0 : options.op) === null || _b === void 0 ? void 0 : _b.cache_time);
                    }
                    return [2 /*return*/, new Promise(function (resolve) {
                            eventEmitter.eventEmitter.emit('sync', {
                                addedProducts: {},
                                removedProducts: {},
                                products: Config.get('products') || {},
                                afterLogin: true
                            });
                            resolve({
                                head: {},
                                op: options === null || options === void 0 ? void 0 : options.op,
                                sr: null,
                                error: null
                            });
                        })];
                }
                buTs = localStore.localStore.get('before_unload');
                useForce = options === null || options === void 0 ? void 0 : options.force;
                if (useForce && Config.get('checkPageRefreshBeforeSync') && buTs) {
                    useForce = buTs + Config.get('checkPageRefreshBeforeSync') < (Date.now() / 1000);
                }
                if (useForce) {
                    localCache.localCache.expire(cacheIndex);
                }
                else if (localCache.localCache.get(cacheIndex)) {
                    return [2 /*return*/, localCache.localCache.get(cacheIndex)];
                }
                this.syncState.req = true;
                return [2 /*return*/, this.sync(options)
                        .then(function (response) {
                        _this.syncState.req = false;
                        while (_this.syncCallbacks.length) {
                            var prom = _this.syncCallbacks.shift();
                            prom.resolve(response);
                        }
                        _this.syncState.failedTime = null;
                        _this.syncState.failedTimes = 0;
                        // this.syncCallbacks.map((prom) => {
                        //     prom.resolve(response);
                        // })
                        return response;
                    })["catch"](function (error) {
                        _this.syncState.req = false;
                        _this.syncState.failedTime = Date.now();
                        _this.syncState.failedTimes = _this.syncState.failedTimes || 0;
                        _this.syncState.failedTimes += 1;
                        // this.syncCallbacks.map((prom) => {
                        //     prom.reject(error);
                        // });
                        while (_this.syncCallbacks.length) {
                            var prom = _this.syncCallbacks.shift();
                            prom.reject(error);
                        }
                        throw error;
                    })];
            });
        });
    };
    Commands.prototype.setUpSyncWatcher = function (timeout) {
        var _this = this;
        if (timeout === void 0) { timeout = 60000; }
        if (timeout < 10000) {
            timeout = 10000;
        }
        if (!Config.get('user.id')) {
            return;
        }
        if (this.syncState.timeoutId) {
            clearTimeout(this.syncState.timeoutId);
            this.syncState.timeoutId = null;
        }
        this.syncState.timeoutId = setTimeout(function () {
            if (!Config.get('user.id')) {
                return;
            }
            var req = _this.customSync({ force: true });
            req.then(function (data) {
                data = data || {};
                var cacheTime = (data.op || {}).cache_time || timeout;
                _this.setUpSyncWatcher(cacheTime);
            })["catch"](function () {
                if (_this.syncState.failedTimes < 4) {
                    _this.setUpSyncWatcher(60000 * _this.syncState.failedTimes);
                }
            });
        }, timeout);
    };
    Commands.prototype.getTimestamp = function (date, time, timeZoneOffset) {
        if (timeZoneOffset === void 0) { timeZoneOffset = 0; }
        var d = date.split('-');
        var t = time.split(':');
        return Date.UTC(+d[0], (+d[1]) - 1, +d[2], +t[0], +t[1], +t[2]) - timeZoneOffset;
    };
    /**
     * @method setUpCommandsWatcher
     * */
    Commands.prototype.setUpCommandsWatcher = function () {
        var _this = this;
        if (this.commandsWatcherId) {
            this.destroyCommandsWatcher();
        }
        if (!Config.get('user.id') || (!this.commandsConf || !this.commandsConf.cgap || !this.commandsConf.ep)) {
            // in the case when the AMS does not return config for the commands handler
            return;
        }
        this.commandsWatcherId = setTimeout(function () {
            _this.loadServerCommands()
                .then(function (response) {
                _this.errorsCorrection = 0;
                var lastTime = _this.commandsCheckTime;
                var commandsStack = [];
                var actualCommands = response.dr.filter(function (command, index, array) {
                    var _a = command.time.split(' '), _date = _a[0], _time = _a[1];
                    var cTime = _this.getTimestamp(_date, _time);
                    if (command.op === 'sync') {
                        var cacheIndex = _this.syncCacheIndex();
                        var syncCache = localCache.localCache.get(cacheIndex);
                        if ((syncCache === null || syncCache === void 0 ? void 0 : syncCache.cacheTs) && syncCache.cacheTs > cTime) { // if the cache already was done, done after the command generated
                            return false;
                        }
                    }
                    if (!_this.commandsCheckTime || _this.commandsCheckTime < cTime) {
                        if (!lastTime || cTime > lastTime) {
                            lastTime = cTime;
                        }
                        if (!commandsStack.includes(command.op)) { // to prevent duplicating commands
                            commandsStack.push(command.op);
                            return true;
                        }
                    }
                    return false;
                });
                _this.commandsCheckTime = lastTime;
                _this.handleServerCommands(actualCommands);
                _this.applyYozhikConf(response);
                _this.setUpCommandsWatcher();
            })["catch"](function (error) {
                _this.$logger.p('setUpCommandsWatcher').error(error);
                _this.errorsCorrection += 10000; //10sec
                if (_this.errorsCorrection > 100000) { // 100 sec/10 times
                    _this.$logger.p('setUpCommandsWatcher').warn('Stopped handling commands (too many errors!)', error);
                    return;
                }
                _this.setUpCommandsWatcher();
            });
        }, (this.commandsConf.cgap * 1000) + this.errorsCorrection);
        this.$logger.p('setUpCommandsWatcher')
            .debug("Commands watcher set up, interval: ".concat(this.commandsConf.cgap, "s, errorsCorrection: ").concat(this.errorsCorrection));
    };
    Commands.prototype.destroyCommandsWatcher = function () {
        clearInterval(this.commandsWatcherId);
        this.commandsWatcherId = null;
    };
    Commands.prototype.loadServerCommands = function ( /*signal: AbortSignal*/) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, doFetch.doFetch("".concat(getCurrentProtocol.getCurrentProtocol(), "//").concat(normDomain.normDomain(this.commandsConf.ep), "/comm/dr/"), {
                        headers: {
                            usid: Config.get('user.id'),
                            ak: this.commandsConf.ak
                        }
                        // signal: signal
                    })];
            });
        });
    };
    Commands.prototype.handleServerCommands = function (serverCommands) {
        return __awaiter(this, void 0, void 0, function () {
            var i, command;
            return __generator(this, function (_a) {
                for (i = 0; i < serverCommands.length; i++) {
                    command = serverCommands[i];
                    switch (command.op) {
                        case 'sync':
                            this.customSync({ force: true });
                            break;
                    }
                }
                return [2 /*return*/];
            });
        });
    };
    Commands.prototype.syncCacheIndex = function () {
        var url = formatPath.formatPath('/accounts/sync/', true, getAccessData());
        return getUrlCacheIndex.getUrlCacheIndex(url);
    };
    Commands.prototype.sync = function (options) {
        var _this = this;
        if (options === void 0) { options = null; }
        if (this.client.analyticsModule) {
            this.client.analyticsModule.send('sync_sent');
        }
        var cacheIndex = this.syncCacheIndex();
        return this.client.callAms('/accounts/sync/', {
            cache: false,
            query: {
                gst: Config.get('user.guest') ? 1 : 0
            }
        }).then(function (data) {
            var _a, _b, _c;
            //for keep the localstorage in clear state
            localCache.localCache.clean();
            sessionCache.sessionCache.clean();
            if (_this.client.analyticsModule) {
                _this.client.analyticsModule.send('sync_ok');
            }
            if (!data.info || !data.info.user_info || !data.info.user_info.is_active) {
                eventEmitter.eventEmitter.emit('auth_state_change', {
                    type: 'inactive'
                });
                eventEmitter.eventEmitter.emit('_logout', {
                    type: 'inactive'
                });
                return null;
            }
            var upAmsData = {};
            var currentProducts = Config.get('products') || {};
            var currentIds = Object.keys(currentProducts);
            var newProducts = formatProducts(data.info.products_list || data.info.prodcuts_list || {});
            var newIds = Object.keys(newProducts);
            var addedProducts = {};
            var removedProducts = {};
            for (var i = 0; i < currentIds.length; i++) {
                var cId = currentIds[i];
                if (!newIds.includes(cId)) {
                    removedProducts[cId] = currentProducts[cId];
                }
            }
            for (var i = 0; i < newIds.length; i++) {
                var nId = newIds[i];
                if (!currentIds.includes(nId)) {
                    addedProducts[nId] = newProducts[nId];
                }
            }
            var addedOffers = {};
            var removedOffers = {};
            try {
                var currentOffers = Config.get('offers') || {};
                var currentOffersIds = Object.keys(currentOffers);
                var newOffers = formatProducts(data.info.offers_list || {});
                var newOffersIds = Object.keys(newOffers);
                for (var i = 0; i < currentOffersIds.length; i++) {
                    var cId = currentOffersIds[i];
                    if (!newOffersIds.includes(cId)) {
                        removedOffers[cId] = currentOffers[cId];
                    }
                }
                for (var i = 0; i < newOffersIds.length; i++) {
                    var nId = newOffersIds[i];
                    if (!currentOffersIds.includes(nId)) {
                        addedOffers[nId] = newOffers[nId];
                    }
                }
                if (Object.keys(removedOffers).length || Object.keys(addedOffers).length) {
                    Config.set('offers', null);
                    upAmsData.offers = newOffers;
                }
            }
            catch (e) {
                _this.$logger.p('sync').error(e);
                throw e;
            }
            if (Object.keys(removedProducts).length || Object.keys(addedProducts).length) {
                Config.set('products', null);
                upAmsData.products = newProducts;
            }
            var currentConcurrency = Config.get('concurrency');
            if (currentConcurrency && data.info.concur && (currentConcurrency.cgrp !== data.info.concur.cgrp || currentConcurrency.cgap !== data.info.concur.cgap)) {
                upAmsData.concurrency = data.info.concur;
            }
            if (data.info.buh) {
                upAmsData.buh = Object.assign({}, Config.get('buh'), data.info.buh);
            }
            var userData = {
                consent: data.head.consent || data.info.consent,
                classes: data.info.classes || Config.get('user.classes'),
                consent_dtypes: data.head.consent_dtypes || data.info.consent_dtypes,
                in_sync: (_a = data.info.user_info) === null || _a === void 0 ? void 0 : _a.in_sync,
                adlevel: data.head.adlevel || ((_b = data.info.user_info) === null || _b === void 0 ? void 0 : _b.adlevel),
                adsetup: data.head.adsetup || ((_c = data.info.user_info) === null || _c === void 0 ? void 0 : _c.adsetup),
                preview_info: Config.get('user.preview_info')
            };
            if (data.info.preview_info) {
                userData.preview_info = {
                    daily_seconds: data.info.preview_info.daily_minutes * 60,
                    daily_over_message: data.info.preview_info.daily_over_message
                };
            }
            var buhChanged = false;
            /** todo: to discuss this part*/
            // if (data.info.buh) {
            //   for (const k in data.info.buh) {
            //     let key = `buh.${k}`;
            //     if (Config.get(key as 'buh') !== data.info.buh[k]) {
            //       buhChanged = true
            //       break;
            //     }
            //   }
            //   console.log('[buhChanged]', buhChanged, data.info.buh, Config.get('buh'))
            //   if (buhChanged) {
            //     let buh: AMSBuhInf = Object.assign({}, Config.get('buh') || {}, data.info.buh);
            //     updateAmsData.buh = buh;
            //   }
            // }
            upAmsData.user = Object.assign({}, Config.get('user'), userData);
            updateAMSData(upAmsData);
            if (Object.keys(removedProducts).length || Object.keys(addedProducts).length) {
                if (_this.client.analyticsModule) {
                    _this.client.analyticsModule.send('products_updated', {
                        added_products_offers: __spreadArray(__spreadArray([], Object.keys(addedProducts), true), Object.keys(addedOffers), true),
                        removed_products_offers: __spreadArray(__spreadArray([], Object.keys(removedProducts), true), Object.keys(removedOffers), true),
                        store_server: 'AIS'
                    });
                }
            }
            eventEmitter.eventEmitter.emit('sync', {
                addedProducts: addedProducts,
                removedProducts: removedProducts,
                products: newProducts,
                afterLogin: !!(options === null || options === void 0 ? void 0 : options.afterLogin),
                buhChanged: buhChanged
            });
            var cachedData = Object.assign({ cacheTs: Date.now() }, data.head);
            localCache.localCache.set(cacheIndex, cachedData, (data.op || {}).cache_time);
            return data;
        })["catch"](function (error) {
            // if (error.code === ErrorCodes.AMS_ERR) {
            // respTime = respTime || Date.now();
            // }
            var _a;
            eventEmitter.eventEmitter.emit('auth_state_change', {
                type: 'sync_error',
                error: error
            });
            if (((_a = error === null || error === void 0 ? void 0 : error.meta) === null || _a === void 0 ? void 0 : _a.amsCode) === 60403) {
                eventEmitter.eventEmitter.emit('_logout', {
                    type: 'inactive'
                });
            }
            else {
                if (_this.client.analyticsModule) {
                    _this.client.analyticsModule.send('sync_error', {}, { error: error });
                }
            }
            throw error;
        }); /*.finally(() => {
          if (respTime && this.client.analyticsModule) {
            this.client.analyticsModule.send('ams_response', {
              ams_url: url.toString(),
              cached: false
            }, {
              duration: respTime - callDuration
            })
          }
        })*/
    };
    Commands.prototype.applyYozhikConf = function (newConf) {
        if (this.commandsConf.cgap !== newConf.cgap) {
            this.applyConf(Object.assign({}, this.commandsConf, { cgap: newConf.cgap }));
            /** it updating the conf and re-create the watcher with new interval */
            this.initWatcher();
            this.$logger.p('YozhikConf').debug("loaded new 'cgap' (".concat(newConf.cgap, "), applied!"));
        }
    };
    Commands.prototype.applyConf = function (newConf) {
        if (this.commandsConf && newConf && (this.commandsConf.ak !== newConf.ak || this.commandsConf.cgap !== newConf.cgap || this.commandsConf.ep !== newConf.ep)) {
            this.commandsConf = Object.assign({}, this.commandsConf, newConf);
            updateAMSData({
                commands: this.commandsConf
            });
        }
    };
    Commands.prototype.destroy = function () {
        this.destroyCommandsWatcher();
        this.errorsCorrection = 0;
        if (this.syncState.timeoutId) {
            clearTimeout(this.syncState.timeoutId);
            this.syncState.timeoutId = null;
        }
    };
    return Commands;
}());

var Stock = /** @class */ (function () {
    function Stock(client) {
        this.client = client;
    }
    Stock.prototype.loadData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var favorites, recent, watchLater;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getFavorites()];
                    case 1:
                        favorites = _a.sent();
                        return [4 /*yield*/, this.getRecent()];
                    case 2:
                        recent = _a.sent();
                        return [4 /*yield*/, this.getWatchLater()];
                    case 3:
                        watchLater = _a.sent();
                        updateAMSData({
                            stock: {
                                favorites: favorites,
                                recent: recent,
                                watchLater: watchLater
                            }
                        });
                        eventEmitter.eventEmitter.emit('stock', {});
                        return [2 /*return*/];
                }
            });
        });
    };
    Stock.prototype.freeData = function () {
        updateAMSData({
            stock: null
        });
    };
    /** Recent*/
    Stock.prototype.isItemInRecent = function (itemId) {
        var state = Config.get('stock.recent');
        return state && state.indexOf(itemId) !== -1;
    };
    Stock.prototype.setRecent = function (itemId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!itemId) {
                    throw new appError.AppError(errorCodes.ErrorCodes.MISS_PARAMETER, 'Missed parameter "pk"', 'parameter "pk" is required!');
                }
                if ((Config.get('stock.recent') || []).indexOf(itemId) !== -1) {
                    return [2 /*return*/, Config.get('stock.recent')];
                }
                return [2 /*return*/, this.client.callAms('/stk/recent/', {
                        query: {
                            pk: itemId
                        },
                        method: 'post',
                        withDeviceRestrictions: false
                    }).then(function (data) {
                        // respTime = Date.now();
                        Config.set('stock.recent', []);
                        updateAMSData({
                            stock: {
                                recent: data.info
                            }
                        });
                        return data.info;
                    })];
            });
        });
    };
    Stock.prototype.getRecent = function (formatted, start, count) {
        if (formatted === void 0) { formatted = true; }
        if (start === void 0) { start = null; }
        if (count === void 0) { count = null; }
        return __awaiter(this, void 0, void 0, function () {
            var query;
            return __generator(this, function (_a) {
                query = {};
                if (start != undefined && count) {
                    query.start = start.toString();
                    query.count = count.toString();
                }
                return [2 /*return*/, this.client.callAms('/stk/get/recent/', {
                        cache: false,
                        query: query
                    }).then(function (data) {
                        if (formatted === 'raw') {
                            return data;
                        }
                        else if (formatted) {
                            if (Array.isArray(data.items)) {
                                return data.items.map(function (el) {
                                    return el.id;
                                });
                            }
                            else {
                                return [];
                            }
                        }
                        return data.items;
                    })];
            });
        });
    };
    /** Favorite*/
    Stock.prototype.isItemFavorite = function (itemId) {
        var state = Config.get('stock.favorites');
        if (state) {
            for (var key in state) {
                if (state[key].indexOf(itemId) !== -1) {
                    return true;
                }
            }
        }
        return false;
    };
    Stock.prototype.startFavoriteLive = function (itemId) {
        return this.startFavorite('item_live', itemId);
    };
    Stock.prototype.startFavoriteMovie = function (itemId) {
        return this.startFavorite('item_mov_vod', itemId);
    };
    Stock.prototype.startFavoriteEpisode = function (itemId) {
        return this.startFavorite('item_mov_episode', itemId);
    };
    Stock.prototype.stopFavoriteLive = function (itemId) {
        return this.stopFavorite('item_live', itemId);
    };
    Stock.prototype.stopFavoriteMovie = function (itemId) {
        return this.stopFavorite('item_mov_vod', itemId);
    };
    Stock.prototype.stopFavoriteEpisode = function (itemId) {
        return this.stopFavorite('item_mov_episode', itemId);
    };
    Stock.prototype.startFavorite = function (itype, itemId) {
        return this.setFavorite(itype, itemId, 'start');
    };
    Stock.prototype.stopFavorite = function (itype, itemId) {
        return this.setFavorite(itype, itemId, 'stop');
    };
    Stock.prototype.setFavorite = function (itype, itemId, op) {
        var _this = this;
        return this.client.callAms('/stk/favorites/', {
            method: 'post',
            query: {
                itype: itype,
                op: op,
                pk: itemId
            },
            body: null,
            cache: false
        }).then(function (data) {
            var items = data.info;
            var formattedItems = {};
            items.map(function (item) {
                var parsed = item.split(':');
                formattedItems[parsed[1]] = formattedItems[parsed[1]] || [];
                formattedItems[parsed[1]].push(parsed[0]);
            });
            if (_this.client.analyticsModule) {
                _this.client.analyticsModule.send(op === 'start' ? 'favorite_item' : 'unfavorite_item', {
                    item_id: itemId,
                    itype: itype
                });
            }
            Config.set('stock.favorites', {});
            updateAMSData({
                stock: {
                    favorites: formattedItems
                }
            });
            return formattedItems;
        });
    };
    Stock.prototype.getFavoriteMovies = function (formatted, start, count) {
        if (formatted === void 0) { formatted = true; }
        if (start === void 0) { start = null; }
        if (count === void 0) { count = null; }
        return this.getFavorites(formatted, start, count, 'item_mov_vod');
    };
    Stock.prototype.getFavoriteEpisodes = function (formatted, start, count) {
        if (formatted === void 0) { formatted = true; }
        if (start === void 0) { start = null; }
        if (count === void 0) { count = null; }
        return this.getFavorites(formatted, start, count, 'item_mov_episode');
    };
    Stock.prototype.getFavoriteLive = function (formatted, start, count) {
        if (formatted === void 0) { formatted = true; }
        if (start === void 0) { start = null; }
        if (count === void 0) { count = null; }
        return this.getFavorites(formatted, start, count, 'item_live');
    };
    Stock.prototype.getFavorites = function (formatted, start, count, itype) {
        if (formatted === void 0) { formatted = true; }
        if (start === void 0) { start = undefined; }
        if (count === void 0) { count = 0; }
        if (itype === void 0) { itype = null; }
        var query = {};
        if (start != undefined && count) {
            query.start = start.toString();
            query.count = count.toString();
        }
        if (itype) {
            query.itype = itype;
        }
        return this.client.callAms('/stk/get/favorites/', {
            cache: false,
            query: query
        }).then(function (data) {
            if (formatted === 'raw') {
                return data;
            }
            else if (formatted) {
                var formattedList_1 = {};
                if (Array.isArray(data.items)) {
                    data.items.map(function (el) {
                        formattedList_1[el.itype] = formattedList_1[el.itype] || [];
                        formattedList_1[el.itype].push(el.id);
                    });
                }
                return itype ? formattedList_1[itype] ? formattedList_1[itype] : [] : formattedList_1;
            }
            else {
                return data.items;
            }
        });
    };
    /** Watch Later*/
    Stock.prototype.isItemWatchLater = function (itemId) {
        var state = Config.get('stock.watchLater');
        if (state) {
            for (var key in state) {
                if (state[key].indexOf(itemId) !== -1) {
                    return true;
                }
            }
        }
        return false;
    };
    Stock.prototype.startWatchLater = function (itype, itemId) {
        return this.setWatchLater(itype, itemId, 'start');
    };
    Stock.prototype.stopWatchLater = function (itype, itemId) {
        return this.setWatchLater(itype, itemId, 'stop');
    };
    Stock.prototype.setWatchLater = function (itype, itemId, op) {
        if (Config.get('user.guest') && Config.get('appInfo.customer') === 'ais') {
            return null;
        }
        return this.client.callAms('/stk/watch_later/', {
            method: 'post',
            cache: false,
            query: {
                itype: itype,
                op: op,
                pk: itemId
            },
            body: null
        }).then(function (data) {
            var items = data.info;
            var formattedItems = {};
            items.map(function (item) {
                var parsed = item.split(':');
                formattedItems[parsed[1]] = formattedItems[parsed[1]] || [];
                formattedItems[parsed[1]].push(parsed[0]);
            });
            Config.set('stock.watchLater', {});
            updateAMSData({
                stock: {
                    watchLater: formattedItems
                }
            });
            return formattedItems;
        });
    };
    Stock.prototype.getWatchLater = function (formatted, start, count, itype) {
        if (formatted === void 0) { formatted = true; }
        if (start === void 0) { start = undefined; }
        if (count === void 0) { count = 0; }
        if (itype === void 0) { itype = null; }
        var query = {};
        if (start != undefined && count) {
            query.start = start.toString();
            query.count = count.toString();
        }
        if (itype) {
            query.itype = itype;
        }
        if (Config.get('user.guest') && Config.get('appInfo.customer') === 'ais') {
            return null;
        }
        return this.client.callAms('/stk/get/watch_later/', {
            cache: false,
            query: query
        }).then(function (data) {
            if (formatted === 'raw') {
                return data;
            }
            else if (formatted) {
                var formattedList_2 = {};
                if (Array.isArray(data.items)) {
                    data.items.map(function (el) {
                        formattedList_2[el.itype] = formattedList_2[el.itype] || [];
                        formattedList_2[el.itype].push(el.id);
                    });
                }
                return itype ? formattedList_2[itype] ? formattedList_2[itype] : [] : formattedList_2;
            }
            else {
                return data.items;
            }
        });
    };
    /** Resume watching*/
    Stock.prototype.setMovieResumeWatch = function (movie_id, position) {
        if (position === void 0) { position = 0; }
        return this.setResumeWatch(movie_id, movie_id, movie_id, position);
    };
    Stock.prototype.setEpisodeResumeWatch = function (series_id, season_id, episode_id, position) {
        if (position === void 0) { position = 0; }
        return this.setResumeWatch(series_id, season_id, episode_id, position);
    };
    Stock.prototype.setResumeWatch = function (series_id, season_id, episode_id, position) {
        if (position === void 0) { position = 0; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!position || (Config.get('user.guest') && Config.get('appInfo.customer') === 'ais')) {
                    return [2 /*return*/, null];
                }
                return [2 /*return*/, this.client.callAms('/stk/series_info/', {
                        method: 'post',
                        keepalive: true,
                        query: {
                            series: series_id,
                            season: season_id,
                            episode: episode_id + ':' + position
                        },
                        body: null
                    }).then(function (data) {
                        return data.items;
                    })];
            });
        });
    };
    Stock.prototype.getResumeWatch = function (item_id, series_id) {
        if (item_id === void 0) { item_id = null; }
        if (series_id === void 0) { series_id = null; }
        return __awaiter(this, void 0, void 0, function () {
            var query;
            return __generator(this, function (_a) {
                query = {};
                if (item_id || series_id) { /// movie_id || series_id
                    query.series = series_id || item_id;
                }
                if (Config.get('user.guest') && Config.get('appInfo.customer') === 'ais') {
                    return [2 /*return*/, null];
                }
                return [2 /*return*/, this.client.callAms('/stk/series_info/', {
                        cache: false,
                        query: query
                    }).then(function (data) {
                        if (item_id || series_id) {
                            var item = data.info;
                            if (!item || typeof item !== 'string') {
                                return null;
                            }
                            var parsed = item.split(':');
                            var formattedItem = {};
                            if (!series_id) { // movie
                                formattedItem = {
                                    time: parsed[2]
                                };
                            }
                            else if (item_id === parsed[1] || (!item_id && series_id)) { //episode
                                formattedItem = {
                                    series: series_id,
                                    season: parsed[0],
                                    episode: parsed[1],
                                    time: parsed[2]
                                };
                            }
                            return formattedItem;
                        }
                        else {
                            var items = data.info;
                            if (!items) {
                                return null;
                            }
                            var formattedItems = {};
                            for (var s_id in items) {
                                var parsed = items[s_id].split(':');
                                if (parsed[0] === s_id) { // movie
                                    formattedItems[s_id] = {
                                        time: parsed[2]
                                    };
                                }
                                else { //episode
                                    formattedItems[s_id] = {
                                        series: s_id,
                                        season: parsed[0],
                                        episode: parsed[1],
                                        time: parsed[2]
                                    };
                                }
                            }
                            return formattedItems;
                        }
                    })];
            });
        });
    };
    Stock.prototype.getDailyPreviewTime = function (pk, separateResp) {
        if (pk === void 0) { pk = null; }
        if (separateResp === void 0) { separateResp = false; }
        return this.client.callAms('/stk/daily_preview/', {
            cache: false
        }).then(function (data) {
            var itemTime = null;
            if (pk && data.info && data.info[pk] && data.info[pk].date) {
                var lastDate = new Date(data.info[pk].date);
                var currentDate = new Date();
                if ((currentDate.getTime() - lastDate.getTime()) < 86400000 && lastDate.getDate() === currentDate.getDate()) {
                    itemTime = +data.info[pk].consumed_time;
                }
                else {
                    itemTime = 0;
                }
            }
            if (separateResp && pk) {
                return {
                    item: itemTime,
                    full: (data === null || data === void 0 ? void 0 : data.info) ? +data.info.consumed_daily_preview : 0
                };
            }
            else if (pk) {
                return itemTime;
            }
            return (data === null || data === void 0 ? void 0 : data.info) ? +data.info.consumed_daily_preview : null;
        });
    };
    Stock.prototype.setDailyPreviewTime = function (time, pk, previewTime, mode, isPageTerminated) {
        if (pk === void 0) { pk = null; }
        if (previewTime === void 0) { previewTime = null; }
        if (mode === void 0) { mode = 'item'; }
        var query = {};
        if (pk && mode === 'item') {
            query[pk] = time;
            if (previewTime) {
                query.preview_time = previewTime;
            }
        }
        else if (pk) {
            query.preview_time = time;
            query.pk = pk;
        }
        return this.client.callAms('/stk/daily_preview/', {
            method: 'post',
            keepalive: !!isPageTerminated,
            body: JSON.stringify({}),
            cache: false,
            query: query
        }).then(function (data) {
            if (mode === 'item' && pk) {
                return data.info && data.info[pk] ? +data.info[pk].consumed_time : 0;
            }
            return +data.info.consumed_daily_preview;
        });
    };
    return Stock;
}());

var Account = /** @class */ (function () {
    function Account(client) {
        this.client = client;
        this.logoutCall = null;
        this.$logger = null;
        this.$logger = this.client.$logger.cl('Account', false);
    }
    /**
     * @method amsLogin
     * @description login into ams
     * @return {AMSData}
     * */
    Account.prototype.amsLogin = function (body, query, headers, options) {
        var _a;
        if (body === void 0) { body = null; }
        if (query === void 0) { query = null; }
        if (headers === void 0) { headers = null; }
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var platform, loginUrl, useDeviceLogin, url, formData, fName, _qNam, callDuration, login_type, customHeaders, reqHeaders, _b, _c, _d, _e, _f, _g, authSendTimestamp, respTime;
            var _this = this;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        if (options === null || options === void 0 ? void 0 : options.guest) {
                            Config.set('deviceRestrictions', ["gst".concat(Config.get('platform'))]);
                        }
                        else if ((_a = options === null || options === void 0 ? void 0 : options.userData) === null || _a === void 0 ? void 0 : _a.second_screen) { // AIS related
                            Config.set('deviceRestrictions', ["2nd".concat(Config.get('platform'))]);
                        }
                        else {
                            Config.set('deviceRestrictions', ["".concat(Config.get('platform'))]);
                        }
                        platform = Config.get('platform');
                        loginUrl = '';
                        useDeviceLogin = (options === null || options === void 0 ? void 0 : options.amsLoginType) === 'device' || (platform === 'web' && Config.get('appInfo.customer') === 'ais');
                        if (useDeviceLogin) {
                            loginUrl = '/device/login/';
                        }
                        else {
                            loginUrl = '/accounts/login/';
                        }
                        url = formatPath.formatPath((options === null || options === void 0 ? void 0 : options.path) || loginUrl, true, getAccessData());
                        formData = new FormData();
                        if (options === null || options === void 0 ? void 0 : options.guest) {
                            url.searchParams.set('gst', String(1));
                        }
                        if (body) {
                            for (fName in body) {
                                formData.append(fName, body[fName]);
                            }
                        }
                        if (query) {
                            for (_qNam in query) {
                                url.searchParams.set(_qNam, query[_qNam]);
                            }
                        }
                        headers = headers || {};
                        callDuration = Date.now();
                        if (this.client.analyticsModule) {
                            this.client.analyticsModule.send('ams_request', {
                                ams_url: url.toString()
                            });
                        }
                        login_type = ['fungus', 'andromeda', 'silent', 'sso'].indexOf(options.login_type) !== -1 ? options.login_type : 'default';
                        customHeaders = {};
                        if (headers.privateId) {
                            customHeaders.privateId = headers.privateId;
                        }
                        reqHeaders = {};
                        if (!Config.get('user.guest')) return [3 /*break*/, 2];
                        _c = (_b = Object).assign;
                        _d = [{}];
                        return [4 /*yield*/, generateHeaders.generateHeaders(customHeaders, getAccessData('', ''))];
                    case 1:
                        reqHeaders = _c.apply(_b, _d.concat([_h.sent(), headers]));
                        return [3 /*break*/, 4];
                    case 2:
                        _f = (_e = Object).assign;
                        _g = [{}];
                        return [4 /*yield*/, generateHeaders.generateHeaders(customHeaders, getAccessData())];
                    case 3:
                        reqHeaders = _f.apply(_e, _g.concat([_h.sent(), headers]));
                        _h.label = 4;
                    case 4:
                        if (Config.get('appInfo.customer') === 'zman' && reqHeaders.privateId) {
                            reqHeaders.user = reqHeaders.privateId;
                            delete reqHeaders.privateId;
                        }
                        reqHeaders['Accept-Language'] = normalizeLang.normalizeLang(Config.get('appInfo.language'), 'iso-2');
                        authSendTimestamp = Date.now();
                        return [2 /*return*/, ((options === null || options === void 0 ? void 0 : options.isGet) ? fetchAMS.fetchAMS.get(url.toString(), {
                                headers: reqHeaders,
                                withCredentials: false
                            }) : fetchAMS.fetchAMS.post(url.toString(), formData, {
                                headers: reqHeaders,
                                withCredentials: false
                            }))
                                .then(function (data) { return __awaiter(_this, void 0, void 0, function () {
                                var amsData, classes, user, buh, concurrency, commands;
                                var _this = this;
                                var _a, _b, _c, _d, _e;
                                return __generator(this, function (_f) {
                                    switch (_f.label) {
                                        case 0:
                                            respTime = Date.now();
                                            if (!data.head.is_active) return [3 /*break*/, 3];
                                            if (!Config.get('user.guest')) return [3 /*break*/, 2];
                                            return [4 /*yield*/, this.logout(true)];
                                        case 1:
                                            _f.sent();
                                            _f.label = 2;
                                        case 2:
                                            classes = data.info.classes || [];
                                            // let operator_id = data.info.operator_id ? data.info.operator_id : classes.length ? classes[0] : null
                                            // operator_id = operator_id || headers['operatorId'] || 'default'
                                            if (!classes.length) {
                                                classes = [Config.get('appInfo.customer') + (options.guest ? '-gst' : '')];
                                            }
                                            user = __assign({ id: data.head.id, username: data.head.username, name: data.head.name, created_at: (_b = (_a = data.head) === null || _a === void 0 ? void 0 : _a.session) === null || _b === void 0 ? void 0 : _b.created_at, is_active: data.head.is_active, sid: data.info.sid, dat: data.info.dat, updated_at: data.info.updated_at, status: data.info.status, 
                                                // privateId: data.head.consent,
                                                // operatorId: operator_id,
                                                consent: data.head.consent || data.info.consent, consent_dtypes: data.head.consent_dtypes || data.info.consent_dtypes, classes: classes, 
                                                // loggedBy: ['fungus', 'andromeda'].indexOf(options.login_type) !== -1 ? options.login_type : 'ams',
                                                login_type: login_type || 'default', adlevel: data.head.adlevel || ((_c = data.info.user_info) === null || _c === void 0 ? void 0 : _c.adlevel), in_sync: (_d = data.info.user_info) === null || _d === void 0 ? void 0 : _d.in_sync, adsetup: data.head.adsetup || ((_e = data.info.user_info) === null || _e === void 0 ? void 0 : _e.adsetup), chat_user: data.head.chat_user || null, preview_info: data.info.preview_info ? {
                                                    daily_seconds: data.info.preview_info.daily_minutes * 60,
                                                    daily_over_message: data.info.preview_info.daily_over_message
                                                } : null, guest: !!options.guest, 
                                                // accessToken: headers['accessToken'] || null, //not used anywhere
                                                privateId: headers['privateId'] || (Config.get('appInfo.customer') === 'verb' ? data.head.username : null) }, (options.userData || {}));
                                            if (user.second_screen) { // AIS related
                                                Config.set('deviceRestrictions', ["2nd".concat(Config.get('platform'))]);
                                            }
                                            else if (user.guest) {
                                                Config.set('deviceRestrictions', ["gst".concat(Config.get('platform'))]);
                                            }
                                            buh = null;
                                            if (data.info.buh) {
                                                buh = Object.assign({}, Config.get('buh') || {}, data.info.buh);
                                            }
                                            concurrency = void 0;
                                            if (data.info.concur) {
                                                concurrency = {
                                                    ep: data.info.concur.ep,
                                                    cgap: data.info.concur.cgap || 50,
                                                    cgrp: data.info.concur.cgrp || null,
                                                    content: data.info.concur.content
                                                };
                                            }
                                            commands = void 0;
                                            if (data.info.comm) {
                                                commands = {
                                                    ep: data.info.comm.ep,
                                                    cgap: data.info.comm.cgap || 50,
                                                    ak: data.info.comm.ak
                                                };
                                            }
                                            amsData = {
                                                user: user,
                                                products: formatProducts(data.info.products_list || data.info.prodcuts_list || {}),
                                                offers: formatProducts(data.info.offers_list || {}),
                                                commands: commands,
                                                concurrency: concurrency,
                                                extraData: Config.get('extraData') || {}
                                            };
                                            if (buh) {
                                                amsData.buh = buh;
                                            }
                                            eventEmitter.eventEmitter.emit('before_auth_state_change', {
                                                type: 'logged',
                                                user: user,
                                                afterGuest: this.client.get('user.guest')
                                            });
                                            setTimeout(function () {
                                                updateAMSData(amsData);
                                                eventEmitter.eventEmitter.emit('auth_state_change', {
                                                    type: 'logged',
                                                    afterGuest: _this.client.get('user.guest')
                                                });
                                                clearInterval(_this.client.cacheInterval);
                                                _this.client.handleCommands(data.op.cache_time);
                                                _this.client.commandsHandler.customSync({ afterLogin: true, force: useDeviceLogin })["catch"](function (error) {
                                                    _this.$logger.p('amsLogin').warn('Error during initialization', error);
                                                });
                                                if (!Config.get('user.guest') || Config.get('appInfo.customer') !== 'ais') {
                                                    _this.client.stock.loadData();
                                                }
                                                if (_this.client.analyticsModule) {
                                                    if (data.info.user_info && data.info.user_info.session) {
                                                        var TZoffset = (new Date()).getTimezoneOffset() * 60 * 1000;
                                                        // when session created time not less than 1 minute = user login first time
                                                        if ((new Date(data.info.user_info.session.created_at)).getTime() > (Date.now() + TZoffset - 60000)) {
                                                            _this.client.analyticsModule.send('sid_create', {
                                                                login_type: login_type
                                                            });
                                                        }
                                                    }
                                                    _this.client.analyticsModule.send('auth_ok', {
                                                        login_type: login_type
                                                    });
                                                }
                                            });
                                            return [3 /*break*/, 4];
                                        case 3: throw new appError.AppError(errorCodes.ErrorCodes.USER_INACTIVE, '403 - User not active', '');
                                        case 4: return [2 /*return*/, JSON.parse(JSON.stringify(amsData))];
                                    }
                                });
                            }); })["catch"](function (error) {
                                // if (error.code === ErrorCodes.AMS_ERR) {
                                respTime = respTime || Date.now();
                                // }
                                if (_this.client.analyticsModule) {
                                    _this.client.analyticsModule.send('auth_error', {
                                        login_type: login_type
                                    }, { error: error });
                                }
                                throw error;
                            })["finally"](function () {
                                if (respTime && _this.client.analyticsModule) {
                                    _this.client.analyticsModule.send('ams_response', {
                                        ams_url: url.toString(),
                                        cached: false
                                    }, { duration: respTime - callDuration });
                                }
                                setTimeout(function () {
                                    if (_this.client.analyticsModule) {
                                        _this.client.analyticsModule.send('auth_sent', {
                                            login_type: login_type
                                        }, { buffer_timestamp: authSendTimestamp });
                                    }
                                });
                            })];
                }
            });
        });
    };
    /**
     * for login through AMS
     * */
    Account.prototype.login = function (login, password, options) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var body, query;
            return __generator(this, function (_a) {
                body = {};
                query = {};
                if (Config.get('appInfo.customer') === 'zman') {
                    query = {
                        user: login,
                        pass: password
                    };
                }
                else {
                    body = {
                        user: login,
                        pass: password
                    };
                }
                return [2 /*return*/, this.amsLogin(body, query, { privateId: login }, options)];
            });
        });
    };
    /**
     * for login through guest
     * */
    Account.prototype.guestLogin = function (options) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var guestLogin, guestPass, headers;
            return __generator(this, function (_a) {
                if (!(guestLogin = this.client.get('extraData.guestLogin'))) {
                    // guestLogin = makeId(12);
                    guestLogin = Config.get('authInfo.device_id').slice(0, 10).split('').reverse().join('');
                    this.client.setExtraData('guestLogin', guestLogin);
                }
                if (!(guestPass = this.client.get('extraData.guestPass'))) {
                    // guestPass = makeId(12);
                    guestPass = Config.get('authInfo.device_id').slice(10, 20).split('').reverse().join('');
                    this.client.setExtraData('guestPass', guestPass);
                }
                headers = {};
                // if (Config.get('appInfo.customer') === 'ais') {
                headers.privateId = guestLogin;
                // }
                return [2 /*return*/, this.amsLogin({}, {
                        user: guestLogin,
                        pass: guestPass
                    }, headers, Object.assign(options, { guest: true, login_type: 'silent' }))];
            });
        });
    };
    /**
     * for login through OreId
     * */
    Account.prototype.oreIdLogin = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var pass;
            return __generator(this, function (_a) {
                this.client.setExtraData('access_token', options.access_token);
                this.client.setExtraData('account', options.account);
                this.client.setExtraData('process_id', options.process_id);
                pass = options.account.split('').reverse().join('');
                return [2 /*return*/, this.amsLogin({}, {
                        user: options.account,
                        pass: pass
                        // register: 'yes'
                    }, {}, options)];
            });
        });
    };
    /**
     * for login through google
     * */
    Account.prototype.googleLogin = function (code, options) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.client.setExtraData('code', code);
                // let pass = options.account.split("").reverse().join("");
                return [2 /*return*/, this.amsLogin({}, { code: code }, {}, __assign({ path: '/google/login/', isGet: true }, options))];
            });
        });
    };
    /**
     * for login through google
     * */
    Account.prototype.facebookLogin = function (code, options) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.client.setExtraData('code', code);
                return [2 /*return*/, this.amsLogin({}, { code: code }, {}, __assign({ path: '/facebook/login/', isGet: true }, options))];
            });
        });
    };
    Account.prototype.logout = function (isGuest) {
        if (isGuest === void 0) { isGuest = false; }
        return __awaiter(this, void 0, void 0, function () {
            var opt;
            var _this = this;
            return __generator(this, function (_a) {
                if (!this.client.isAuth()) {
                    return [2 /*return*/, true];
                }
                if (this.logoutCall) {
                    return [2 /*return*/, new Promise(function (resolve, reject) {
                            _this.logoutCall.then(function (data) {
                                resolve(data);
                                return data;
                            })["catch"](function (error) {
                                reject(error);
                                throw error;
                            });
                        })];
                }
                this.logoutStart = true;
                // Config.set('logoutStart', true);
                if (this.client.commandsHandler) {
                    this.client.commandsHandler.destroy();
                }
                if (this.client.stock) {
                    this.client.stock.freeData();
                }
                localCache.localCache.clean(true);
                sessionCache.sessionCache.clean(true);
                opt = { cache: false };
                if (isGuest) {
                    opt.deviceRestrictions = 'gst' + Config.get('platform');
                }
                this.client.watchCache();
                this.logoutCall = this.client.callAms('/accounts/logout/?_t=' + parseInt(String(Date.now() / 1000 / 10))
                    .toString(), opt)
                    .then(function (data) {
                    if (data.error) {
                        throw new appError.AppError(errorCodes.ErrorCodes.AMS_ERR, "".concat(data.error, " - ").concat((data.info || { msg: 'unknown error in deleteUser' }).msg), '');
                    }
                    return true;
                })["finally"](function () {
                    Config.set('deviceRestrictions', [Config.get('platform')]);
                    // Config.set('logoutStart', false);
                    _this.logoutStart = false;
                    _this.logoutCall = null;
                    var abs = Config.get('customer.abs');
                    Config.set('customer', null);
                    eventEmitter.eventEmitter.emit('before_auth_state_change', {
                        type: 'logout'
                    });
                    setTimeout(function () {
                        updateAMSData({
                            customer: { abs: abs },
                            user: null,
                            products: null,
                            offers: null,
                            commands: null,
                            concurrency: null,
                            extraData: Config.get('extraData') || {}
                        });
                        if (!isGuest) {
                            eventEmitter.eventEmitter.emit('auth_state_change', { type: 'logout' });
                        }
                    });
                });
                return [2 /*return*/, this.logoutCall];
            });
        });
    };
    Account.prototype.register = function (userData) {
        if (userData === void 0) { userData = null; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!userData || !userData.email || !userData.password) {
                    throw new appError.AppError(errorCodes.ErrorCodes.MISS_PARAMETER, "parameters \"email\" and \"password\" required!", '');
                }
                userData.confirm_password = userData.password;
                return [2 /*return*/, this.client.callAms('/accounts/register/', {
                        method: 'post',
                        body: JSON.stringify(userData)
                    }).then(function (response) {
                        return response.head;
                    })];
            });
        });
    };
    Account.prototype.registerConfirm = function (pk, code) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!pk || !code) {
                    throw new appError.AppError(errorCodes.ErrorCodes.MISS_PARAMETER, "parameters \"pk\" and \"code\" required!", '');
                }
                return [2 /*return*/, this.client.callAms("/accounts/register_confirm/".concat(pk, "/?code=").concat(code), {
                        cache: false
                    }).then(function (response) {
                        return response.head;
                    })];
            });
        });
    };
    Account.prototype.update = function (user) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (Config.get('user.guest')) {
                    return [2 /*return*/];
                }
                return [2 /*return*/, this.client.callAms('/accounts/update/', {
                        method: 'post',
                        cache: false,
                        body: JSON.stringify(user)
                    }).then(function (data) {
                        updateAMSData({ user: user });
                        return data;
                    })];
            });
        });
    };
    Account.prototype.resendRegisterConfirm = function (email, resetPass) {
        if (resetPass === void 0) { resetPass = null; }
        return __awaiter(this, void 0, void 0, function () {
            var body;
            return __generator(this, function (_a) {
                if (!email) {
                    throw new appError.AppError(errorCodes.ErrorCodes.MISS_PARAMETER, "parameters \"email\" required!", '');
                }
                body = { email: email };
                if (resetPass)
                    Object.assign(body, { 'reset_password': resetPass });
                return [2 /*return*/, this.client.callAms("/accounts/resend_confirm/", {
                        method: 'post',
                        body: JSON.stringify(body)
                    }).then(function (response) { return response.head; })];
            });
        });
    };
    Account.prototype.deleteUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                // let url = formatPath('/accounts/delete/', true, getAccessData());
                return [2 /*return*/, this.client.callAms('/accounts/delete/', {
                        method: 'post',
                        body: JSON.stringify({})
                    })
                        .then(function (data) {
                        if (data.error) {
                            throw new appError.AppError(errorCodes.ErrorCodes.AMS_ERR, "".concat(data.error, " - ").concat((data.info || { msg: 'unknown error in deleteUser' }).msg), '');
                        }
                        else {
                            return _this.logout();
                        }
                    })];
            });
        });
    };
    /** deprecated: need to call account sync instead*/
    // public async getViewerProducts(id: string = null) {
    //   return this.client.callAms('/accounts/products_list/', { cache: false }).then((result: AMSResponse) => {
    //     let productsList = result.info || []
    //     if (id) {
    //       return productsList.find((item: AMSProductsInf) => {
    //         return item.id === id
    //       })
    //     }
    //     return productsList || []
    //   })
    // }
    /**
     * @param prdid {string} PRODUCT_ID
     * @param purid {string} PURCHASE_ID
     * @param coupon {string} COUPON_CODE
     * */
    // public async confirmPurchase(prdid: string, purid: string = null, coupon: string = null) {
    //   if (!purid && !coupon) {
    //     if (!prdid) {
    //       throw new AppError(ErrorCodes.MISS_PARAMETER, `parameters "prid" required!`, '')
    //     }
    //     await this.client.commandsHandler.customSync({ force: true })
    //     return true
    //   } else {
    //     if (Config.get('user.guest')) {
    //       return
    //     }
    //     return this.client.callAms(`/accounts/confirm/?coup=${coupon}&purid=${purid}&prdid=${prdid}`, {
    //       cache: false,
    //       method: 'post'
    //     }).then(async (result: AMSResponse) => {
    //       await this.client.commandsHandler.customSync({ force: true })
    //       return true
    //     })
    //   }
    // }
    /**
     * (verb) reset password
     * @param itemOrPRId {string} ite or product id
     * @param couponCode {string} Coupon can be used to get discount
     * */
    // public getOffer(itemOrPRId: string, couponCode: string = null) {
    //   return this.client.callAms(`/accounts/offer/${itemOrPRId}/${couponCode ? '?coup=' + couponCode : ''}`, {
    //     cache: false
    //   }).then((result: AMSResponse) => {
    //     const { info, head } = result
    //     return { info, head } || {}
    //   })
    // }
    /** (verb) reset password
     * todo: move to separate file
     * */
    Account.prototype.verifyToken = function (pk, token, changePass, newPass, newPassRepeat) {
        if (changePass === void 0) { changePass = null; }
        if (newPass === void 0) { newPass = null; }
        if (newPassRepeat === void 0) { newPassRepeat = null; }
        if (!pk || !token) {
            throw new appError.AppError(errorCodes.ErrorCodes.MISS_PARAMETER, "parameters \"pk\" and \"token\" required!", '');
        }
        var options = {
            cache: false,
            method: 'post'
        };
        var body = { pk: pk, token: token };
        if (changePass && newPass && newPassRepeat) {
            Object.assign(body, {
                'change_password': changePass,
                'new_password': newPass,
                'new_password_repeat': newPassRepeat
            });
        }
        options.body = JSON.stringify(body);
        return this.client.callAms("/accounts/reset_password/", options).then(function (response) { return response.head; });
    };
    return Account;
}());

Config.set({
    checkPageRefreshBeforeSync: null,
    defaultAmsCache: true,
    secondLocation: false,
    thirdLocation: false,
    version: "1.7.234",
    buildDate: "2023-01-12T19:10:49.540Z",
    NODE_ENV: "production",
    platform: 'web',
    appInfo: {
        'Api-Version': '2.8.2'
    }
});
var AMSClient = /** @class */ (function () {
    function AMSClient(initialConf) {
        var _this = this;
        this.$logger = new StyledLogger__default["default"]('AMSClient', {
            debug: {
                active: true,
                level: StyledLogger__default["default"].TRACE_LEVEL
            }
        });
        this.stock = new Stock(this);
        this.account = new Account(this);
        this.cacheInterval = null;
        this.subscribers = [];
        this.analyticsModule = null;
        this.vimmiAIInstance = null;
        this.localStorageLoaded = false;
        this.get = Config.get.bind(Config);
        /** @description update data inside the amsClient, please use the method carefully!!! */
        this.set = function (key, value) {
            Config.set(key, value);
            if (_this.localStorageLoaded) {
                updateAMSData();
            }
        };
        localCache.localCache.clean();
        sessionCache.sessionCache.clean();
        this.conf(initialConf);
    }
    AMSClient.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var amsData, conf, logoutEvent;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.$logger.force().groupCollapsed("AMSClient Version: ".concat(Config.get('version')));
                        this.$logger.force().info("Build Date: ".concat(Config.get('buildDate')));
                        this.$logger.force().groupEnd();
                        Config.set({
                            user: null,
                            products: null,
                            commands: null,
                            concurrency: null
                        });
                        amsData = localStore.localStore.get('amsData') || null;
                        if (amsData) {
                            Config.set(amsData);
                            this.localStorageLoaded = true;
                        }
                        secondLocation.secondLocation.disable(); // just for clear localStorage
                        if (Config.get('appInfo.customer') === 'ais' && Config.get('secondLocation')) {
                            secondLocation.secondLocation.setEnv(Config.get('env'));
                            secondLocation.secondLocation.setScreenType(Config.get('screenType'));
                            secondLocation.secondLocation.setPlatform(Config.get('platform'));
                            secondLocation.secondLocation.enable();
                        }
                        thirdLocation.thirdLocation.disable(); // just for clear localStorage
                        if (!(Config.get('appInfo.customer') === 'ais' && Config.get('thirdLocation'))) return [3 /*break*/, 2];
                        thirdLocation.thirdLocation.set('env', Config.get('env'));
                        thirdLocation.thirdLocation.set('platform', Config.get('platform'));
                        return [4 /*yield*/, thirdLocation.thirdLocation.enable()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (Config.get('user.second_screen')) {
                            Config.set('deviceRestrictions', ["2nd".concat(Config.get('platform'))]);
                        }
                        else if (Config.get('user.guest')) {
                            Config.set('deviceRestrictions', ["gst".concat(Config.get('platform'))]);
                        }
                        return [4 /*yield*/, this.loadAMSConf()];
                    case 3:
                        conf = _a.sent();
                        Config.set('conf', conf);
                        logoutEvent = eventEmitter.eventEmitter.on('_logout', function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.account.logout()];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        this.subscribers.push(logoutEvent);
                        setTimeout(function () {
                            eventEmitter.eventEmitter.emit('conf', conf, { watchCallbacks: true });
                            if (_this.isAuth()) {
                                eventEmitter.eventEmitter.emit('auth_state_change', {
                                    type: 'logged'
                                });
                                _this.handleCommands(60000);
                                _this.commandsHandler.customSync({ force: true })["catch"](function () {
                                });
                                if (!Config.get('user.guest') || Config.get('appInfo.customer') !== 'ais') {
                                    _this.stock.loadData();
                                }
                            }
                            else {
                                _this.watchCache();
                                eventEmitter.eventEmitter.emit('auth_state_change', {
                                    type: 'no-user'
                                });
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    AMSClient.prototype.activeBackend = function () {
        return secondLocation.secondLocation.isEnabled() ? secondLocation.secondLocation.getBackDomain() : thirdLocation.thirdLocation.isEnabled() ? thirdLocation.thirdLocation.get('activeDomain') : this.get('backend') || location.host;
    };
    //  todo search in the app for formatAMSLink and replace
    AMSClient.prototype.formatPath = function (link, withDR) {
        if (withDR === void 0) { withDR = true; }
        return formatPath.formatPath(link, withDR, getAccessData());
    };
    AMSClient.prototype.watchCache = function () {
        if (this.cacheInterval) {
            clearInterval(this.cacheInterval);
        }
        this.cacheInterval = setInterval(function () {
            localCache.localCache.clean();
            sessionCache.sessionCache.clean();
        }, 5 * 60000);
    };
    AMSClient.prototype.loadAMSConf = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.callAms('/conf/', { cache: true })
                        .then(function (amsRes) {
                        var conf = Object.assign({}, amsRes.head, amsRes.conf);
                        /** preferred to use from login response */
                        var amsData = {};
                        if (conf.buh) {
                            amsData.buh = {
                                ep: conf.buh.ep,
                                chugap: conf.buh.chugap,
                                stkwrite: conf.buh.stkwrite,
                                egap: conf.buh.egap,
                                package: conf.buh.package,
                                nstk: conf.buh.nstk,
                                buhsy: conf.buh.buhsy !== undefined ? conf.buh.buhsy : Config.get('buh.buhsy'),
                                olsy: conf.buh.olsy !== undefined ? conf.buh.olsy : Config.get('buh.olsy'),
                                packageOpt: {
                                    minEvents: 40,
                                    maxEvents: 50
                                }
                            };
                        }
                        conf.fbq = Object.assign({}, conf.fbq || {}, conf.portal.fbq || {});
                        if (Object.keys(conf.fbq).length) {
                            amsData.fbq = __assign({}, conf.fbq);
                        }
                        conf.gtm = Object.assign({}, conf.gtm || {}, conf.portal.gtm || {});
                        if (Object.keys(conf.gtm).length) {
                            amsData.gtm = __assign({}, conf.gtm);
                        }
                        if (conf.portal && conf.portal.abs) {
                            amsData.customer = { abs: conf.portal.abs };
                        }
                        if (conf.ads) {
                            amsData.ads = conf.ads;
                        }
                        if (Object.keys(amsData).length) {
                            updateAMSData(amsData);
                        }
                        if (conf.portal.eapp) {
                            conf.portal.oreId = conf.portal.eapp;
                            delete conf.portal.eapp;
                        }
                        delete conf.buh;
                        return conf;
                    })];
            });
        });
    };
    AMSClient.prototype.handleCommands = function (cache_time) {
        if (cache_time === void 0) { cache_time = 1; }
        if (!this.commandsHandler) {
            this.commandsHandler = new Commands(this);
            this.commandsHandler.initWatcher(cache_time);
        }
        else {
            this.commandsHandler.applyConf(Config.get('commands'));
            this.commandsHandler.initWatcher(cache_time);
        }
    };
    AMSClient.prototype.setExtraData = function (key, value) {
        if (key) {
            Config.set("extraData.".concat(key), value);
            updateAMSData({ extraData: Config.get("extraData") });
            return true;
        }
    };
    AMSClient.prototype.isAuth = function () {
        /** todo: privateId - used only for AIS */
        return !!(Config.get('user') && Config.get('user.sid') /*&& Config.get('user.privateId')*/ && Config.get('user.id'));
    };
    AMSClient.prototype.getAMSDeviceInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, getDeviceInfo.getDeviceInfoAsync(getAccessData())];
            });
        });
    };
    /**
     * for generate the api_key, assuming that the api_key using only inside the client
     * @deprecated
     * @return {object}*/
    AMSClient.prototype.generateApiKey = function () {
        var time = parseInt(String(Date.now() / 1000));
        return {
            time: time,
            api_key: getApiKey.getApiKey(time, {}, getAccessData())
        };
    };
    /**
     * call AMS with all needed headers and query parameters
     * @param {string=null} path - the query url ex "/screen/main/"
     * @param {CallAMSOptions} options - key -> value request options
     * */
    AMSClient.prototype.callAms = function (path, options) {
        return __awaiter(this, void 0, void 0, function () {
            var method, addDQueryParam, pathPrefix, urlPath, url, key, customHeaders, request, _a, _b, _c, callDuration, respTime, isCached;
            var _d;
            var _this = this;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (!path) {
                            throw new appError.AppError(errorCodes.ErrorCodes.USER_ERR, '"path" is missed!', '');
                        }
                        method = ((options === null || options === void 0 ? void 0 : options.method) || 'get').toLowerCase();
                        addDQueryParam = (options === null || options === void 0 ? void 0 : options.withDeviceRestrictions) === undefined || (options === null || options === void 0 ? void 0 : options.withDeviceRestrictions);
                        pathPrefix = this.get('conf.pathPrefix');
                        urlPath = pathPrefix ? (pathPrefix + path) : path;
                        url = formatPath.formatPath(urlPath, addDQueryParam, getAccessData());
                        if ((options === null || options === void 0 ? void 0 : options.query) && Object.keys(options.query).length) {
                            for (key in options.query) {
                                url.searchParams.set(key, options.query[key]);
                            }
                        }
                        if (addDQueryParam && (options === null || options === void 0 ? void 0 : options.deviceRestrictions)) {
                            url.searchParams.set('d', options.deviceRestrictions.toString());
                        }
                        customHeaders = {};
                        if (this.get('conf.store.standalone') && this.get('conf.store.slug')) {
                            customHeaders.standalone = this.get('conf.store.slug');
                        }
                        _d = {
                            method: method,
                            useCache: !!(Config.get('defaultAmsCache') && (options === null || options === void 0 ? void 0 : options.cache) === undefined) || (options === null || options === void 0 ? void 0 : options.cache)
                        };
                        _b = (_a = Object).assign;
                        _c = [{ 'Accept-Language': normalizeLang.normalizeLang(Config.get('appInfo.language'), 'iso-2') }, options === null || options === void 0 ? void 0 : options.headers];
                        return [4 /*yield*/, generateHeaders.generateHeaders({}, getAccessData())];
                    case 1:
                        request = (_d.headers = _b.apply(_a, _c.concat([_e.sent()])),
                            _d);
                        if (options === null || options === void 0 ? void 0 : options.body) {
                            request.body = options.body;
                        }
                        if (options === null || options === void 0 ? void 0 : options.abortSignal) {
                            request.signal = options.abortSignal;
                        }
                        if ((options === null || options === void 0 ? void 0 : options.keepalive) !== undefined) {
                            request.keepalive = options.keepalive;
                        }
                        callDuration = Date.now();
                        if (this.analyticsModule) {
                            this.analyticsModule.send('ams_request', {
                                ams_url: url.toString()
                            });
                        }
                        isCached = false;
                        return [2 /*return*/, fetchAMS.fetchAMS.request(url.toString(), request)
                                .then(function (data) {
                                respTime = Date.now();
                                data.ams_url = url.toString();
                                isCached = !!data.cached;
                                return data;
                            })["catch"](function (error) {
                                respTime = respTime || Date.now();
                                throw error;
                            })["finally"](function () {
                                /** need to send event if ams return any response (not network error!) */
                                if (respTime && _this.analyticsModule) {
                                    _this.analyticsModule.send('ams_response', {
                                        ams_url: url.toString(),
                                        cached: isCached
                                    }, {
                                        duration: respTime - callDuration
                                    });
                                }
                            })];
                }
            });
        });
    };
    AMSClient.prototype.getAMSHeaders = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, generateHeaders.generateHeaders({}, getAccessData())];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Attach analytics module
     * @param {object}   externalAnalyticsService - analytics module instance
     * @param {function} externalAnalyticsService.send - send method
     */
    AMSClient.prototype.attachAnalytics = function (externalAnalyticsService) {
        this.analyticsModule = externalAnalyticsService;
    };
    AMSClient.prototype.vimmiAIInit = function (VimmiAIClass, options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        if (!VimmiAIClass) {
            this.$logger.p('vimmiAIInit').warn('\'VimmiAIClass\' required!');
            throw new appError.AppError(errorCodes.ErrorCodes.USER_ERR, "VimmiAIClass required!", '');
        }
        if (this.vimmiAIInstance) {
            this.$logger.p('vimmiAIInit').warn('\'VimmiAIClass\' already instantiate!!');
            throw new appError.AppError(errorCodes.ErrorCodes.USER_ERR, 'VimmiAIClass already instantiate!', '');
        }
        this.vimmiAIInstance = new VimmiAIClass();
        var analyticsConf = {
            platform: Config.get('platform'),
            app_id: Config.get('appInfo.app_id'),
            app_version: Config.get('appInfo.app_version'),
            language: Config.get('appInfo.language'),
            device_id: Config.get('authInfo.device_id') // udid
        };
        this.vimmiAIInstance.conf(analyticsConf);
        eventEmitter.eventEmitter.on('auth_state_change', function (event, data) {
            if (data.type === 'logged') {
                /** conf for analytic driver */
                _this.vimmiAIInstance.conf(__assign({}, Config.get('buh')), null, VimmiAIClass.DRIVERS.BUH);
            }
        });
        eventEmitter.eventEmitter.on('sync', function (data) {
            /** conf for analytic driver */
            if (data.buhChanged) {
                _this.vimmiAIInstance.conf(__assign({}, Config.get('buh')), null, VimmiAIClass.DRIVERS.BUH);
            }
        });
        eventEmitter.eventEmitter.on('conf', function (event, data) {
            var drivers = [];
            if (Config.get('buh') && (!options.drivers || options.drivers.indexOf('buh') !== -1)) {
                drivers.push(_this.vimmiAIInstance.setDriver(VimmiAIClass.DRIVERS.BUH, __assign({}, Config.get('buh'))));
            }
            if (Config.get('fbq') && (!options.drivers || options.drivers.indexOf('fbq') !== -1)) {
                drivers.push(_this.vimmiAIInstance.setDriver(VimmiAIClass.DRIVERS.FBQ, __assign({}, Config.get('fbq'))));
            }
            if (Config.get('gtm') && (!options.drivers || options.drivers.indexOf('gtm') !== -1)) {
                drivers.push(_this.vimmiAIInstance.setDriver(VimmiAIClass.DRIVERS.GTM, __assign({}, Config.get('gtm'))));
            }
            Promise.all(drivers).then(function () {
                var err = _this.vimmiAIInstance.initialize();
                if (err) {
                    _this.$logger.p('vimmiAIInit').warn({
                        buh: !!(Config.get('buh') && (!options.drivers || options.drivers.indexOf('buh') !== -1)),
                        fbq: !!(Config.get('fbq') && (!options.drivers || options.drivers.indexOf('fbq') !== -1)),
                        gtm: !!(Config.get('gtm') && (!options.drivers || options.drivers.indexOf('gtm') !== -1))
                    }, err);
                }
            });
        }, null, { watchEvent: true });
        return this.vimmiAIInstance;
    };
    AMSClient.prototype.getSubscriptionStatus = function (item) {
        if (this.isContentPremium(item)) {
            return 'paid';
        }
        else if (this.isContentFreemium(item)) {
            return 'freemium';
        }
        else {
            return 'free';
        }
    };
    AMSClient.prototype.getProductsOffersStatus = function (item) {
        //“ok”, “cancel”, “purchase”, “second_screen”, "not_allowed"
        if (Config.get('user.second_screen')) {
            return 'second_screen';
        }
        if (this.isContentPremium(item)) {
            if (this.canPlayPremium(item)) {
                return 'ok';
            }
            else {
                return 'not_allowed';
            }
        }
        else if (this.isContentFreemium(item)) {
            if (this.canPlayFreemium(item)) {
                return 'ok';
            }
            else {
                return 'not_allowed';
            }
        }
        return 'ok';
    };
    AMSClient.prototype.isContentPremium = function (item) {
        return AMSContentType__default["default"].isContentPremium(item);
    };
    AMSClient.prototype.isContentFreemium = function (item) {
        return AMSContentType__default["default"].isContentFreemium(item);
    };
    AMSClient.prototype.canPlayPremium = function (item) {
        var products = Config.get('products') || {};
        var offers = Config.get('offers') || {};
        var itemProducts = item.products || [];
        var itemOffers = item.offers || [];
        if (Config.get('user.guest')) {
            return false;
        }
        if (!item.not_free)
            return true;
        var productsMatch = itemProducts.filter(function (productId) {
            return !!products[productId];
        });
        var offersMatch = itemOffers.filter(function (offerId) {
            return !!offers[offerId];
        });
        return !!productsMatch.length || !!offersMatch.length;
    };
    AMSClient.prototype.canPlay = function (item) {
        if (Config.get('platform') !== 'stv' && Config.get('user.in_sync') === false &&
            ((Config.get('user.classes')[0] === 'ais' && this.isContentPremium(item)) ||
                (Config.get('user.classes')[0] === 'non-ais' && (this.isContentPremium(item) || this.isContentFreemium(item))))) {
            return false;
        }
        return (!item.not_free && !this.isContentFreemium(item) && !this.isContentPremium(item)) || (this.isContentFreemium(item) && this.canPlayFreemium(item)) || (this.isContentPremium(item) && this.canPlayPremium(item));
    };
    AMSClient.prototype.canPlayFreemium = function (item) {
        var classes = Config.get('user.classes') || [];
        var products = Config.get('products') || {};
        var offers = Config.get('offers') || {};
        var itemProducts = item.products || [];
        var itemOffers = item.offers || [];
        var itemClasses = item.classes || [];
        if (Config.get('user.guest')) {
            return false;
        }
        /** AIS users can play all content */
        if (classes.indexOf('non-ais') === -1) {
            return true;
        }
        // currently works only for "non_ais"
        var classesMatch = itemClasses.filter(function (oneClass) {
            return classes.indexOf(oneClass) !== -1;
        });
        if (classesMatch.length) {
            var offersMatch = itemOffers.filter(function (offerId) {
                return !!offers[offerId];
            });
            var productsMatch = itemProducts.filter(function (productId) {
                return !!products[productId];
            });
            return !!offersMatch.length || !!productsMatch.length;
        }
        return false;
    };
    AMSClient.prototype.getActiveProductsOffers = function (item) {
        // let classes = Config.get('user.classes') || [];
        var products = Config.get('products') || {};
        var offers = Config.get('offers') || {};
        var itemProducts = item.products || [];
        var itemOffers = item.offers || [];
        // let itemClasses = item.classes || [];
        // currently works only for "non_ais"
        // let classesMatch = itemClasses.filter((oneClass: string) => {
        //     return classes.indexOf(oneClass) !== -1;
        // });
        // if (classesMatch.length) {
        var offersMatch = itemOffers.filter(function (offerId) {
            return !!offers[offerId];
        });
        var productsMatch = itemProducts.filter(function (productId) {
            return !!products[productId];
        });
        return {
            offers: offersMatch,
            products: productsMatch
        };
    };
    AMSClient.prototype.isShowPreview = function (item) {
        if (item.preview !== undefined) {
            return item.preview;
        }
        var res = !!item.preview_info &&
            (
            // item.not_free &&
            ((this.isContentPremium(item) && !this.canPlayPremium(item))
                ||
                    (this.isContentFreemium(item) && !this.canPlayFreemium(item))));
        item.preview = res;
        return res;
    };
    AMSClient.prototype.getItemPreviewInfo = function (item) {
        return __awaiter(this, void 0, void 0, function () {
            var maxSeconds, previewInfo, usrPreviewInf, fullLeftSeconds;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        maxSeconds = Config.get('user.preview_info.daily_seconds');
                        if (!(this.isShowPreview(item) && maxSeconds)) return [3 /*break*/, 2];
                        previewInfo = {
                            preview_end: 0,
                            full_viewed_time: 0,
                            consumed_time: 0,
                            preview_start: 0
                        };
                        previewInfo.preview_end = item.preview_info.preview_end;
                        previewInfo.preview_start = item.preview_info.preview_start;
                        return [4 /*yield*/, this.stock.getDailyPreviewTime(item.id, true)];
                    case 1:
                        usrPreviewInf = _a.sent();
                        fullLeftSeconds = (maxSeconds - usrPreviewInf.full);
                        previewInfo.full_viewed_time = usrPreviewInf.full;
                        if (fullLeftSeconds < (item.preview_info.preview_end - item.preview_info.preview_start)) {
                            previewInfo.preview_end = fullLeftSeconds + item.preview_info.preview_start;
                        }
                        if (usrPreviewInf.item) {
                            if (usrPreviewInf.item < (item.preview_info.preview_end - item.preview_info.preview_start)) {
                                previewInfo.preview_end = item.preview_info.preview_end - usrPreviewInf.item;
                                previewInfo.consumed_time = usrPreviewInf.item;
                            }
                            else {
                                previewInfo.preview_end = item.preview_info.preview_start;
                            }
                        }
                        return [2 /*return*/, previewInfo];
                    case 2: return [2 /*return*/, null];
                }
            });
        });
    };
    /**
     * Subscribe on the plugin events
     * @param {string} eventName
     * @param {function} handler
     * @return {this}
     */
    AMSClient.prototype.on = function (eventName, handler) {
        return eventEmitter.eventEmitter.on(eventName, handler);
    };
    AMSClient.prototype.one = function (eventName, handler) {
        return eventEmitter.eventEmitter.one(eventName, handler);
    };
    /**
     * Unsubscribe handler from event
     * @param {string} eventName
     * @param {function} handler
     * @return {this}
     */
    AMSClient.prototype.off = function (eventName, handler) {
        return eventEmitter.eventEmitter.off(eventName, handler);
    };
    AMSClient.prototype.conf = function (data) {
        var _a;
        if (!data || typeof data !== 'object') {
            return null;
        }
        if ((_a = data === null || data === void 0 ? void 0 : data.appInfo) === null || _a === void 0 ? void 0 : _a.language) {
            data.appInfo.language = normalizeLang.normalizeLang(data.appInfo.language, 'iso-2');
        }
        if (data === null || data === void 0 ? void 0 : data.platform) {
            var device_restriction = data.platform;
            if (this.isAuth() && Config.get('user.second_screen')) {
                device_restriction = "2nd".concat(device_restriction);
            }
            else if (this.isAuth() && Config.get('user.guest')) {
                device_restriction = "gst".concat(device_restriction);
            }
            Config.set('deviceRestrictions', [device_restriction]);
        }
        Config.set(data);
        if (this.vimmiAIInstance) {
            this.vimmiAIInstance.conf({
                language: Config.get('appInfo.language'),
                device_id: Config.get('authInfo.device_id')
            });
        }
        return this;
    };
    AMSClient.ERROR_CODES = Object.assign({}, errorCodes.ErrorCodes);
    AMSClient.AppError = appError.AppError;
    return AMSClient;
}());

var AisApiV1 = /** @class */ (function () {
    function AisApiV1(client) {
        var _this = this;
        this.client = client;
        this.conf = { clientId: '', platform: 'WEB', loginType: 'auto_apple' };
        this.origin = ''; // todo:
        this.apiPath = '/api/v1/';
        eventEmitter.eventEmitter.one('conf', function () {
            if (Config.get('platform') === 'web') {
                _this.parseConfForPortal();
            }
        });
    }
    AisApiV1.prototype.formatPath = function (path, addVersion) {
        if (addVersion === void 0) { addVersion = true; }
        return "".concat(this.origin).concat(addVersion ? this.apiPath : '/').concat(path);
    };
    /** used on portal */
    AisApiV1.prototype.parseConfForPortal = function () {
        var abs = Config.get('customer.abs');
        try {
            for (var key in abs) {
                var fname = atob(key);
                var val = atob(abs[key]);
                switch (fname) {
                    case 'clientId':
                        this.conf.clientId = val;
                        break;
                    case 'logoutHostUrl':
                        var link = new URL(val);
                        this.origin = link.origin;
                        break;
                }
            }
        }
        catch (e) {
            console.warn('Error while parsing data [abs]', e);
        }
    };
    AisApiV1.prototype.configure = function (conf) {
        if (conf === null || conf === void 0 ? void 0 : conf.origin) {
            this.origin = conf === null || conf === void 0 ? void 0 : conf.origin;
        }
        if (conf === null || conf === void 0 ? void 0 : conf.apiPath) {
            this.apiPath = conf === null || conf === void 0 ? void 0 : conf.apiPath;
        }
        if (conf === null || conf === void 0 ? void 0 : conf.clientId) {
            this.conf.clientId = conf === null || conf === void 0 ? void 0 : conf.clientId;
        }
        if (conf === null || conf === void 0 ? void 0 : conf.platform) {
            this.conf.platform = conf === null || conf === void 0 ? void 0 : conf.platform;
        }
    };
    AisApiV1.prototype.refreshToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var xAccessToken, xExpireIn, b2cData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        xAccessToken = Config.get('customer.xAccessToken');
                        xExpireIn = Config.get('customer.xExpireIn');
                        if (xExpireIn - 10000 >= Date.now()) {
                            return [2 /*return*/, { xAccessToken: xAccessToken, xExpireIn: xExpireIn }];
                        }
                        return [4 /*yield*/, this.loginByB2C(true)];
                    case 1:
                        b2cData = _a.sent();
                        updateAMSData({
                            customer: {
                                idValue: b2cData.idValue,
                                idType: b2cData.idType,
                                operatorId: b2cData.operatorId,
                                xExpireIn: +b2cData.expireIn + Date.now(),
                                xSessionId: b2cData['x-session-id'],
                                xAccessToken: b2cData.accessToken,
                                xPartnerSpecificId: b2cData['x-partner-specific-id'],
                                xApp: b2cData['x-app']
                            }
                        });
                        return [2 /*return*/, b2cData];
                }
            });
        });
    };
    AisApiV1.prototype.loginByB2C = function (refreshToken) {
        if (refreshToken === void 0) { refreshToken = false; }
        return __awaiter(this, void 0, void 0, function () {
            var headers;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        headers = {};
                        if (this.client.analyticsModule && !refreshToken) {
                            this.client.analyticsModule.send('fungus_login_attempt');
                        }
                        return [4 /*yield*/, doFetch.doFetch(this.formatPath('stbLoginByB2C', false), {
                                method: 'post',
                                rawResponse: true,
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify(__assign({ clientId: this.conf.clientId, loginType: this.conf.loginType, commandId: makeHash.makeHash(20) }, (refreshToken ? { privateId: Config.get('user.privateId') } : {}))),
                                errorFormatter: 'AIS'
                            }).then(function (response) {
                                if (!response.ok) {
                                    throw formatAISError.formatAISError(null, response);
                                }
                                response.headers.forEach(function (value, key) {
                                    headers[key] = value;
                                });
                                return response.json();
                            }).then(function (b2cData) {
                                if (parseInt(b2cData === null || b2cData === void 0 ? void 0 : b2cData.resultCode) === 20000) {
                                    // taken from fungus sdk!
                                    b2cData.idType = b2cData.idType === 'E.164' ? '0' : b2cData.idType === 'E.164' ? '3' : b2cData.idType;
                                    b2cData['x-session-id'] = headers['x-session-id'];
                                    b2cData['x-partner-specific-id'] = headers['x-partner-specific-id'];
                                    b2cData['x-app'] = headers['x-app'];
                                    return b2cData;
                                }
                                else {
                                    throw formatAISError.formatAISError(b2cData);
                                }
                            })["catch"](function (error) {
                                if (_this.client.analyticsModule) {
                                    _this.client.analyticsModule.send('fungus_login_failure', {}, { error: error });
                                }
                                throw error;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AisApiV1.prototype.userProfile = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // const link = `${Config.get('auth.ais.url')}/users/profile`
                return [2 /*return*/, doFetch.doFetch(this.formatPath('users/profile', false), {
                        query: {
                            clientId: this.conf.clientId,
                            commandId: makeHash.makeHash(20)
                        },
                        errorFormatter: 'AIS'
                    }).then(function (response) {
                        if (parseInt(response === null || response === void 0 ? void 0 : response.resultCode) === 20000) {
                            return response;
                            // const account = response.publicId.split('@')[0]
                            // return account
                        }
                        else {
                            throw formatAISError.formatAISError(response);
                        }
                    })];
            });
        });
    };
    return AisApiV1;
}());

var FungusSdk = /** @class */ (function () {
    function FungusSdk() {
    }
    FungusSdk.loginB2C = function (config) {
        if (!FungusSdk.validateConfig(config)) {
            return FungusSdk.getErrorMessage(90001, '[Fungus] (LoginB2C) Missing key identify');
        }
        if (!FungusSdk.validateURL(config.urlLogin) || !FungusSdk.validateURL(config.urlRegister) ||
            !FungusSdk.validateURL(config.urlBackend)) {
            return FungusSdk.getErrorMessage(90004, '[Fungus] (LoginB2C) Invalid Parameter');
        }
        location.href = config.urlLogin;
    };
    FungusSdk.login = function (config, ol5, callback) {
        if (!FungusSdk.validateConfig(config)) {
            callback(FungusSdk.getErrorMessage(90001, '[Fungus] (App Authen) Missing key identify'));
            return;
        }
        if (!FungusSdk.validateURL(config.urlLogin) || !FungusSdk.validateURL(config.urlRegister) ||
            !FungusSdk.validateURL(config.urlBackend)) {
            callback(FungusSdk.getErrorMessage(90004, '[Fungus] (App Authen) Invalid Parameter'));
            return;
        }
        if (FungusSdk.isJsonWebToken(ol5) == 'not jwt') {
            callback(FungusSdk.getErrorMessage(90010, '(App Authen) JSON Web Token is Incorrect'));
            return;
        }
        else if (FungusSdk.isJsonWebToken(ol5) == 'not json') {
            callback(FungusSdk.getErrorMessage(90014, '(App Authen) Response Not JSON format'));
            return;
        }
        var responseB2C = FungusSdk.parseJwt(ol5);
        if (!responseB2C.resultCode || !responseB2C.developerMessage) {
            callback(FungusSdk.getErrorMessage(90005, '(App Authen) Missing Parameter'));
            return;
        }
        if (responseB2C.resultCode != '20000') {
            responseB2C.developerMessage = '(App Authen) ' + responseB2C.developerMessage;
            callback(responseB2C);
            return;
        }
        else if (!FungusSdk.validateLoginResponse(responseB2C)) {
            callback(FungusSdk.getErrorMessage(90005, '(App Authen) Missing Parameter'));
            return;
        }
        try {
            var requestModel = FungusSdk.getLoginRequestData(config, responseB2C);
            var timeout = (config.timeout && !isNaN(config.timeout)) ? config.timeout : 60000;
            var requestjqXHR = new XMLHttpRequest();
            requestjqXHR.open('POST', config.urlRegister, true);
            requestjqXHR.timeout = timeout;
            requestjqXHR.onreadystatechange = function () {
                if (requestjqXHR.readyState === 4) {
                    try {
                        // @ts-ignore
                        requestjqXHR.responseJSON = JSON.parse(requestjqXHR.response);
                    }
                    catch (e) {
                        console.log(e);
                    }
                    callback(FungusSdk.getLoginResponseData(requestjqXHR));
                }
            };
            requestjqXHR.ontimeout = function (e) {
                requestjqXHR.responseJSON = {};
                callback(FungusSdk.getLoginResponseData(requestjqXHR, timeout));
            };
            requestjqXHR.send(JSON.stringify(requestModel));
        }
        catch (e) {
            console.log(e);
            callback(FungusSdk.getErrorMessage(90099, 'Unknown Error'));
            return;
        }
    };
    FungusSdk.getLoginRequestData = function (config, responseB2C) {
        return {
            xApp: responseB2C.xApp,
            authCode: responseB2C.authCode,
            ol4: responseB2C.ol4,
            privateId: responseB2C.privateId,
            redirectURL: config.urlBackend,
            clientId: config.clientId,
            platform: config.platform,
            ptsAppEnvironmentType: config.ptsAppEnvironmentType
        };
    };
    FungusSdk.getLoginResponseData = function (appAuthenResponse, timeout) {
        if (timeout === void 0) { timeout = null; }
        var headersToReturn = ['x-app', 'x-session-id', 'x-partner-specific-id'];
        if (appAuthenResponse.status == 200 || appAuthenResponse.status == 201) {
            if (FungusSdk.isJsonString(appAuthenResponse.responseText)) {
                if (appAuthenResponse.responseJSON.resultCode && appAuthenResponse.responseJSON.developerMessage) {
                    if (appAuthenResponse.responseJSON.resultCode == '20000') {
                        if (!FungusSdk.validateAppAuthenResponses(appAuthenResponse.responseJSON)) {
                            return FungusSdk.getErrorMessage(90005, '(App Authen) Missing Parameter');
                        }
                        if (appAuthenResponse.responseJSON.idType == 'E.164') {
                            appAuthenResponse.responseJSON.idType = '0';
                        }
                        else if (appAuthenResponse.responseJSON.idType == 'FBBID') {
                            appAuthenResponse.responseJSON.idType = '3';
                        }
                    }
                    else {
                        appAuthenResponse.responseJSON.developerMessage = '(App Authen) ' +
                            appAuthenResponse.responseJSON.developerMessage;
                    }
                    FungusSdk.setResponseHeaders(appAuthenResponse, headersToReturn);
                    return appAuthenResponse.responseJSON;
                }
                else {
                    return FungusSdk.getErrorMessage(90005, '(App Authen) Missing Parameter');
                }
            }
            else {
                return FungusSdk.getErrorMessage(90014, '(App Authen) Response Not JSON format');
            }
        }
        else {
            if (appAuthenResponse.status == 0) {
                if (appAuthenResponse.statusText == 'timeout') {
                    return FungusSdk.getErrorMessage(90008, '[Fungus] (App Authen) Timeout SDK { ' + timeout / 1000 +
                        ' Second }');
                }
                return FungusSdk.getErrorMessage(90007, '[Fungus] (App Authen) Can\'t Connect Backend');
            }
            else {
                if (FungusSdk.isJsonString(appAuthenResponse.responseText)) {
                    if (appAuthenResponse.responseJSON.resultCode && appAuthenResponse.responseJSON.developerMessage) {
                        appAuthenResponse.responseJSON.developerMessage = '(App Authen) ' +
                            appAuthenResponse.responseJSON.developerMessage + ' and HTTP status code was not 200 and 201';
                        FungusSdk.setResponseHeaders(appAuthenResponse, headersToReturn);
                        return appAuthenResponse.responseJSON;
                    }
                    else {
                        return FungusSdk.getErrorMessage(90005, '(App Authen) Missing Parameter and HTTP status code was not 200 and 201');
                    }
                }
                else {
                    return FungusSdk.getErrorMessage(90014, '(App Authen) Response Not JSON format');
                }
            }
        }
    };
    FungusSdk.getErrorMessage = function (errorCode, devMsg) {
        var commonResponse = {
            resultCode: null,
            developerMessage: devMsg,
            userMessage: null,
            moreInfo: null
        };
        switch (errorCode) {
            case 90001:
                commonResponse.resultCode = '90001';
                commonResponse.userMessage = 'Missing key identify';
                break;
            case 90002:
                commonResponse.resultCode = '90002';
                commonResponse.userMessage = 'Incorrect key indentify';
                break;
            case 90003:
                commonResponse.resultCode = '90003';
                commonResponse.userMessage = 'Missing parameter';
                break;
            case 90004:
                commonResponse.resultCode = '90004';
                commonResponse.userMessage = 'Incorrect parameter';
                break;
            case 90005:
                commonResponse.resultCode = '90005';
                commonResponse.userMessage = 'System Error';
                break;
            case 90006:
                commonResponse.resultCode = '90006';
                commonResponse.userMessage = 'Permission deny';
                break;
            case 90007:
                commonResponse.resultCode = '90007';
                commonResponse.userMessage = 'Connection Error';
                break;
            case 90008:
                commonResponse.resultCode = '90008';
                commonResponse.userMessage = 'Connection Timeout';
                break;
            case 90009:
                commonResponse.resultCode = '90009';
                commonResponse.userMessage = 'This service is privilege for AIS customers';
                break;
            case 90010:
                commonResponse.resultCode = '90010';
                commonResponse.userMessage = 'This service is privilege for AIS customers';
                break;
            case 90011:
                commonResponse.resultCode = '90011';
                commonResponse.userMessage = 'Unknown format';
                break;
            case 90014:
                commonResponse.resultCode = '90014';
                commonResponse.userMessage = 'Response Not JSON format';
                break;
            case 90099:
                commonResponse.resultCode = '90099';
                commonResponse.userMessage = 'Unknown Error';
                break;
            default:
                commonResponse.resultCode = '90099';
                commonResponse.userMessage = 'Unknown Error';
                break;
        }
        return commonResponse;
    };
    FungusSdk.setResponseHeaders = function (appAuthenResponse, selectedHeaders) {
        var arr = appAuthenResponse.getAllResponseHeaders()
            .split('\r\n');
        var headers = arr.reduce(function (acc, current, i) {
            var parts = current.split(': ');
            selectedHeaders.some(function (e) {
                if (e.toLowerCase() === parts[0].toLowerCase()) {
                    acc[parts[0]] = parts[1];
                    return true; // break some()
                }
            });
            return acc;
        }, {});
        appAuthenResponse.responseJSON.headers = headers;
    };
    /*
     * Validation
     */
    FungusSdk.isJsonString = function (str) {
        try {
            JSON.parse(str);
        }
        catch (e) {
            return false;
        }
        return true;
    };
    FungusSdk.isJsonWebToken = function (str) {
        try {
            FungusSdk.parseJwt(str);
        }
        catch (e) {
            return e.message;
        }
        return 'true';
    };
    FungusSdk.validateConfig = function (config) {
        //User Configuration
        if (!config || !config.clientId || !config.platform || !config.urlRegister || !config.urlBackend ||
            !config.ptsAppEnvironmentType || !config.urlLogin) {
            return false;
        }
        return true;
    };
    FungusSdk.validateAppAuthenParameters = function (appparam) {
        //Parameter
        if (!appparam || !appparam.xApp || !appparam.authCode || !appparam.ol4 || !appparam.privateId) {
            return false;
        }
        return true;
    };
    FungusSdk.validateAppAuthenResponses = function (appparam) {
        // Pantry response
        if (!appparam || !appparam.accessToken || !appparam.expireIn || !appparam.privateId || !appparam.ptsListOfAPI ||
            !appparam.ol4) {
            return false;
        }
        return true;
    };
    FungusSdk.validateLoginResponse = function (appparam) {
        if (!appparam || !appparam.resultCode || !appparam.developerMessage || !appparam.authCode || !appparam.ol4 ||
            !appparam.privateId || !appparam.xApp) {
            return false;
        }
        return true;
    };
    FungusSdk.validateURL = function (strUrl) {
        //  var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
        //'((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|' + // domain name
        //'((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        //'(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        //'(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        //'(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
        //  return pattern.test(strUrl);
        //var pattern = new RegExp(" /^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i");
        //var pattern = new RegExp("/^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff0-9]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;")
        //diego perini
        var pattern = new RegExp('^' +
            // protocol identifier
            '(?:(?:https?|ftp)://)' +
            // user:pass authentication
            '(?:\\S+(?::\\S*)?@)?' +
            '(?:' +
            // IP address exclusion
            // private & local networks
            //"(?!(?:10|127)(?:\\.\\d{1,3}){3})" +
            //"(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})" +
            //"(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})" +
            // IP address dotted notation octets
            // excludes loopback network 0.0.0.0
            // excludes reserved space >= 224.0.0.0
            // excludes network & broacast addresses
            // (first & last IP address of each class)
            '(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])' +
            '(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}' +
            '(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))' +
            '|' +
            // host name
            '(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)' +
            // domain name
            '(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*' +
            // TLD identifier
            //"(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))" +
            // TLD may end with dot
            '\\.?' +
            ')' +
            // port number
            '(?::\\d{2,5})?' +
            // resource path
            '(?:[/?#]\\S*)?' +
            '$', 'i');
        return pattern.test(strUrl);
    };
    /*
     * Utilities
     */
    // static getUrlVars() {
    //   var vars = [],
    //     hash: any
    //   var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1)
    //     .split('&')
    //   for (var i = 0; i < hashes.length; i++) {
    //     hash = hashes[i].split('=')
    //     vars.push(hash[0])
    //     vars[hash[0]] = hash[1]
    //   }
    //   return vars
    // }
    FungusSdk.parseJwt = function (token) {
        try {
            var base64Url = token.split('.')[1];
            var base64 = base64Url.replace('-', '+')
                .replace('_', '/');
            var decToken = window.atob(base64);
            if (!FungusSdk.isJsonString(decToken)) {
                throw new Error('not json');
            }
            var appparam = JSON.parse(decToken);
            return appparam;
        }
        catch (e) {
            if (e.message == 'not json') {
                throw new Error('not json');
            }
            else {
                throw new Error('not jwt');
            }
        }
    };
    return FungusSdk;
}());

var AisApiV2 = /** @class */ (function () {
    function AisApiV2(client) {
        var _this = this;
        this.client = client;
        this.conf = { clientId: '', platform: 'WEB' };
        this.origin = ''; // todo:
        this.apiPath = '/api/v2/';
        eventEmitter.eventEmitter.one('conf', function () {
            if (Config.get('platform') === 'web') {
                _this.parseConfForPortal();
            }
        });
    }
    AisApiV2.prototype.formatPath = function (path) {
        return "".concat(this.conf.proxy ? '/apiV2' : this.origin).concat(this.apiPath).concat(path);
        // return `${this.origin}${this.apiPath}${path}`
    };
    AisApiV2.prototype.configure = function (conf) {
        if (conf === null || conf === void 0 ? void 0 : conf.origin) {
            this.origin = conf === null || conf === void 0 ? void 0 : conf.origin;
        }
        if (conf === null || conf === void 0 ? void 0 : conf.apiPath) {
            this.apiPath = conf === null || conf === void 0 ? void 0 : conf.apiPath;
        }
        if (conf === null || conf === void 0 ? void 0 : conf.clientId) {
            this.conf.clientId = conf === null || conf === void 0 ? void 0 : conf.clientId;
        }
        if (conf === null || conf === void 0 ? void 0 : conf.apiPath) {
            this.apiPath = conf === null || conf === void 0 ? void 0 : conf.apiPath;
        }
        if (conf === null || conf === void 0 ? void 0 : conf.platform) {
            this.conf.platform = conf === null || conf === void 0 ? void 0 : conf.platform;
        }
        if ((conf === null || conf === void 0 ? void 0 : conf.proxy) !== undefined) {
            this.conf.proxy = conf === null || conf === void 0 ? void 0 : conf.proxy;
        }
    };
    /** used on portal */
    AisApiV2.prototype.parseConfForPortal = function () {
        var abs = Config.get('customer.abs');
        try {
            for (var key in abs) {
                var fname = atob(key);
                var val = atob(abs[key]);
                switch (fname) {
                    case 'contact_number':
                        var link = new URL(val);
                        this.origin = link.origin;
                        break;
                    case 'registerUrl':
                    case 'secondScreenloginHostUrl':
                        val = toCurrentProtocol.toCurrentProtocol(val);
                    default:
                        this.conf[fname] = val;
                }
            }
        }
        catch (e) {
            console.warn('Error while parsing data [abs]', e);
        }
    };
    /** used on portal */
    AisApiV2.prototype.isConfParsed = function () {
        return !!(this.conf.clientId &&
            this.conf.registerUrl &&
            this.conf.backendUrl &&
            this.conf.loginHostUrl &&
            this.conf.secondScreenloginHostUrl &&
            this.conf.headerEnrichment);
    };
    /** used on portal */
    AisApiV2.prototype.getSecondScreenLoginUrl = function (redirectUrl) {
        return "".concat(this.conf.secondScreenloginHostUrl, "/").concat(encodeURIComponent(this.conf.clientId), "?redirect_uri=").concat(encodeURIComponent(redirectUrl), "&headerEnrichment=").concat(encodeURIComponent(this.conf.headerEnrichment));
    };
    /** used on portal */
    AisApiV2.prototype.getLoginUrl = function (redirectUrl) {
        return "".concat(this.conf.loginHostUrl, "/").concat(encodeURIComponent(this.conf.clientId), "?redirect_uri=").concat(encodeURIComponent(redirectUrl));
    };
    /** used on portal */
    AisApiV2.prototype.compileConfig = function (redirectUrl) {
        var doLoginAs2Screen = (this.conf.login_type || '').toLowerCase() === '2ndScreen'.toLowerCase();
        return {
            clientId: this.conf.clientId,
            platform: 'Browser',
            urlBackend: this.conf.backendUrl,
            ptsAppEnvironmentType: this.conf.ptsAppEnvironmentType,
            urlRegister: this.conf.registerUrl,
            urlLogin: doLoginAs2Screen
                ? this.getSecondScreenLoginUrl(redirectUrl)
                : this.getLoginUrl(redirectUrl),
            timeout: 10000
            // contactNumber: this.conf.contact_number
        };
    };
    /** used on portal */
    AisApiV2.prototype.openOl5LoginPage = function (redirectUrl) {
        if (!this.isConfParsed()) {
            throw new appError.AppError(errorCodes.ErrorCodes.APP_ERR, 'Configs not accessible', 'Configs not accessible');
        }
        if (this.client.analyticsModule) {
            this.client.analyticsModule.send('fungus_login_attempt');
        }
        FungusSdk.loginB2C(this.compileConfig(redirectUrl));
        return true;
    };
    /** used on portal */
    AisApiV2.prototype.loginByOl5 = function (ol5, redirectUrl) {
        return __awaiter(this, void 0, void 0, function () {
            var fungusData, error_1, error;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.client.analyticsModule) {
                            this.client.analyticsModule.send('fungus_login_attempt');
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (new Promise(function (resolve, reject) {
                                if (!_this.isConfParsed()) {
                                    reject(new appError.AppError(errorCodes.ErrorCodes.APP_ERR, 'Configs not accessible', ''));
                                    return;
                                }
                                FungusSdk.login(_this.compileConfig(redirectUrl), ol5, function (res) {
                                    res = res || {};
                                    if (res && parseInt(res.resultCode) === 20000) {
                                        resolve(res);
                                    }
                                    else {
                                        var error = formatAISError.formatAISError(res);
                                        reject(error);
                                    }
                                });
                            }))];
                    case 2:
                        fungusData = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        if (this.client.analyticsModule) {
                            this.client.analyticsModule.send('fungus_login_failure', {}, { error: error_1 });
                        }
                        throw error_1;
                    case 4:
                        if (parseInt(fungusData === null || fungusData === void 0 ? void 0 : fungusData.resultCode) === 20000) {
                            return [2 /*return*/, fungusData];
                        }
                        else {
                            error = formatAISError.formatAISError(fungusData);
                            if (this.client.analyticsModule) {
                                this.client.analyticsModule.send('fungus_login_failure', {}, { error: error });
                            }
                            throw error;
                        }
                }
            });
        });
    };
    /** used on portal */
    AisApiV2.prototype.logout = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.client.analyticsModule) {
                            this.client.analyticsModule.send('fungus_logout_attempt');
                        }
                        /// need to do logout call if token expired
                        return [4 /*yield*/, this.client.account.apiV1.refreshToken()];
                    case 1:
                        /// need to do logout call if token expired
                        _a.sent();
                        return [2 /*return*/, doFetch.doFetch(this.conf.logoutHostUrl, {
                                method: 'post',
                                body: JSON.stringify({
                                    clientId: this.conf.clientId,
                                    accessToken: Config.get('customer.xAccessToken'),
                                    ol4: Config.get('customer.ol4')
                                }),
                                headers: {
                                    'Content-Type': 'application/json',
                                    'x-session-id': Config.get('customer.xSessionId'),
                                    'x-partner-specific-id': Config.get('customer.xPartnerSpecificId'),
                                    'x-app': Config.get('customer.xApp')
                                },
                                errorFormatter: 'AIS'
                            })
                                .then(function (data) {
                                if (_this.client.analyticsModule) {
                                    _this.client.analyticsModule.send('fungus_logout_success');
                                }
                                return data;
                            })["catch"](function (error) {
                                if (_this.client.analyticsModule) {
                                    _this.client.analyticsModule.send('fungus_logout_failure', {}, { error: error });
                                }
                                throw error;
                            })];
                }
            });
        });
    };
    /** used on portal */
    /** todo: method long time not used, need to rewrite*/
    AisApiV2.prototype.getContactNumber = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var AIS_TIME, today, date, normalise, data;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.client.account.apiV1.refreshToken()
                        // todo: store the info in the amsdata
                    ];
                    case 1:
                        _b.sent();
                        AIS_TIME = '-07:00';
                        today = new Date().toISOString()
                            .replace('Z', AIS_TIME);
                        date = new Date(today);
                        normalise = function (value) { return value < 10 ? "0".concat(value) : value.toString(); };
                        "".concat(date.getUTCFullYear()).concat(normalise(date.getUTCMonth() + 1)).concat(normalise(date.getUTCDate())).concat(normalise(date.getUTCHours())).concat(normalise(date.getUTCMinutes())).concat(normalise(date.getUTCSeconds()));
                        return [4 /*yield*/, doFetch.doFetch(this.formatPath('getnetworktype'), {
                                method: 'post',
                                headers: {
                                    'Content-Type': 'application/json',
                                    // 'x-ssb-origin': 'Vimmi',
                                    // 'x-ssb-service-origin': 'Vimmi-GetNetworkType',
                                    // 'x-ssb-transaction-id': format,
                                    // 'x-ssb-order-channel': 'WEB',
                                    // 'x-ssb-version': 'v1',
                                    'x-access-token': Config.get('customer.xAccessToken')
                                },
                                body: JSON.stringify({
                                    msisdn: Config.get('customer.msisdn')
                                })
                            })];
                    case 2:
                        data = _b.sent();
                        return [2 /*return*/, ((_a = data === null || data === void 0 ? void 0 : data.detail) === null || _a === void 0 ? void 0 : _a.contactNumber) || null];
                }
            });
        });
    };
    /** used on smarttv */
    AisApiV2.prototype.getOfferPackages = function (itemId) {
        return __awaiter(this, void 0, void 0, function () {
            var data, products, i;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.account.apiV1.refreshToken()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.client.account.getProductsByItem(itemId)];
                    case 2:
                        data = _a.sent();
                        products = [];
                        for (i = 0; i < data.length; i++) {
                            products.push(Object.values(data[i])[0].remote_id);
                        }
                        return [2 /*return*/, doFetch.doFetch(this.formatPath('getOfferPackages'), {
                                method: 'POST',
                                body: JSON.stringify({
                                    'platform': this.conf.platform,
                                    'privateId': Config.get('user.privateId'),
                                    'products': products,
                                    'language': normalizeLang.normalizeLang(Config.get('appInfo.language'), 'iso-2')
                                }),
                                redirect: 'follow',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'x-app': Config.get('customer.xApp'),
                                    'x-access-token': Config.get('customer.xAccessToken')
                                },
                                errorFormatter: 'AIS'
                            })
                                .then(function (response) {
                                var data = response === null || response === void 0 ? void 0 : response.data;
                                if (response === null || response === void 0 ? void 0 : response.error) {
                                    throw formatAISError.formatAISError(response.error);
                                }
                                else if (data) {
                                    return data;
                                }
                                else {
                                    throw new appError.AppError(errorCodes.ErrorCodes.AIS, "no data", '');
                                }
                            })];
                }
            });
        });
    };
    /** used on smarttv */
    AisApiV2.prototype.sendOnetimePassword = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.account.apiV1.refreshToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, doFetch.doFetch(this.formatPath('sendOnetimePassword'), {
                                method: 'POST',
                                body: JSON.stringify({
                                    'sendOneTimePW': {
                                        'msisdn': Config.get('user.privateId'),
                                        'emailAddr': '',
                                        'otpChannel': 'sms',
                                        'service': 'AISPlay',
                                        'accountType': 'all',
                                        'lifeTimeoutMins': '15',
                                        'waitDR': 'false',
                                        'otpDigit': '4',
                                        'refDigit': '4'
                                    }
                                }),
                                redirect: 'follow',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'x-app': Config.get('customer.xApp'),
                                    'x-access-token': Config.get('customer.xAccessToken')
                                },
                                errorFormatter: 'AIS'
                            })
                                .then(function (response) {
                                if (response === null || response === void 0 ? void 0 : response.error) {
                                    throw formatAISError.formatAISError(response.error);
                                }
                                return response;
                            })];
                }
            });
        });
    };
    /** used on smarttv */
    AisApiV2.prototype.verifySubscribePackage = function (_a) {
        var aisPayload = _a.aisPayload, transactionID = _a.transactionID, otp = _a.otp;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.client.account.apiV1.refreshToken()];
                    case 1:
                        _b.sent();
                        return [2 /*return*/, doFetch.doFetch(this.formatPath('verifyReceiptAndSubscribePackage'), {
                                method: 'POST',
                                body: JSON.stringify({
                                    'platform': this.conf.platform,
                                    'privateId': Config.get('user.privateId'),
                                    'receiptNumber': '',
                                    'aisPayload': aisPayload,
                                    'transactionId': transactionID,
                                    'otp': otp
                                }),
                                redirect: 'follow',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'x-app': Config.get('customer.xApp'),
                                    'x-access-token': Config.get('customer.xAccessToken')
                                },
                                errorFormatter: 'AIS'
                            })
                                .then(function (response) {
                                if (response === null || response === void 0 ? void 0 : response.error) {
                                    throw formatAISError.formatAISError(response.error);
                                }
                                return response;
                            })];
                }
            });
        });
    };
    return AisApiV2;
}());

var AisMainApi = /** @class */ (function () {
    function AisMainApi(client) {
        var _this = this;
        this.client = client;
        this.conf = { model: '', udid: '', platform: 'WEB' };
        this.origin = ''; // todo:
        this.apiPath = '/api/v1/';
        eventEmitter.eventEmitter.one('conf', function () {
            // if (Config.get('platform') === 'web') {
            _this.parseConfForPortal();
            // }
        });
    }
    AisMainApi.prototype.formatPath = function (path, type, addVersion) {
        var _a;
        if (type === void 0) { type = 'V-Account'; }
        if (addVersion === void 0) { addVersion = true; }
        if (type === 'V-Account') {
            // AIS have different path for vaccount on dev and prod env!
            var origin_1 = this.origin + (Config.get('env') !== 'prod' || type !== 'V-Account' ? '/' + type : '');
            return "".concat(this.conf.proxy ? '/vaccount' : origin_1).concat(addVersion ? this.apiPath : '/').concat(path);
        }
        else {
            return "".concat(((_a = this.conf.redemption) === null || _a === void 0 ? void 0 : _a.proxy) ? '/redemption' : this.origin + '/redemption').concat(addVersion ? this.apiPath : '/').concat(path);
        }
    };
    /** used on portal */
    AisMainApi.prototype.parseConfForPortal = function () {
        var abs = Config.get('customer.abs');
        try {
            for (var key in abs) {
                var fname = atob(key);
                var val = atob(abs[key]);
                switch (fname) {
                    case 'vaccount':
                        var link = new URL(val);
                        this.origin = link.origin;
                        break;
                }
            }
        }
        catch (e) {
            console.warn('Error while parsing data [abs]', e);
        }
    };
    AisMainApi.prototype.configure = function (conf) {
        if (conf === null || conf === void 0 ? void 0 : conf.origin) {
            this.origin = conf === null || conf === void 0 ? void 0 : conf.origin;
        }
        if (conf === null || conf === void 0 ? void 0 : conf.apiPath) {
            this.apiPath = conf === null || conf === void 0 ? void 0 : conf.apiPath;
        }
        if ((conf === null || conf === void 0 ? void 0 : conf.proxy) !== undefined) {
            this.conf.proxy = conf === null || conf === void 0 ? void 0 : conf.proxy;
        }
        if (conf === null || conf === void 0 ? void 0 : conf.redemption) {
            this.conf.redemption = conf === null || conf === void 0 ? void 0 : conf.redemption;
        }
        if (conf === null || conf === void 0 ? void 0 : conf.model) {
            this.conf.model = conf === null || conf === void 0 ? void 0 : conf.model;
        }
        if (conf === null || conf === void 0 ? void 0 : conf.udid) {
            this.conf.udid = conf === null || conf === void 0 ? void 0 : conf.udid;
        }
        if (conf === null || conf === void 0 ? void 0 : conf.platform) {
            this.conf.platform = conf === null || conf === void 0 ? void 0 : conf.platform;
        }
    };
    AisMainApi.prototype.generateToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var link, sessionId;
            return __generator(this, function (_a) {
                link = this.formatPath('token-auth');
                sessionId = +(Math.random() * 1000000000).toFixed();
                return [2 /*return*/, doFetch.doFetch(link, {
                        method: 'post',
                        body: JSON.stringify({
                            privateId: encodeURIComponent(Config.get('user.privateId')),
                            lang: Config.get('appInfo.language'),
                            platform: this.conf.platform,
                            freemiumPeriodEndDate: (Date.now() / 1000) + (31 * 24 * 60 * 60)
                        }),
                        headers: {
                            'Content-Type': 'application/json',
                            platform: this.conf.platform,
                            'x-session-id': String(sessionId),
                            'x-transaction-id': String(sessionId - 1)
                        },
                        errorFormatter: 'AIS'
                    })
                        .then(function (data) {
                        if (data.statusCode === 200) {
                            //data.result.expiresIn - in minutes
                            var expired = (+data.result.expiresIn * 60 * 1000) + Date.now();
                            updateAMSData({
                                customer: {
                                    accessToken: data.result.accessToken,
                                    refreshToken: data.result.refreshToken,
                                    expireIn: expired
                                }
                            });
                        }
                        else {
                            throw formatAISError.formatAISError(data);
                        }
                        return data.result;
                    })];
            });
        });
    };
    AisMainApi.prototype.refreshToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var link, refreshToken, accessToken, expireIn, sessionId;
            var _this = this;
            return __generator(this, function (_a) {
                link = this.formatPath('refresh-token-auth');
                refreshToken = Config.get('customer.refreshToken');
                accessToken = Config.get('customer.accessToken');
                expireIn = Config.get('customer.expireIn');
                if (!refreshToken) { // if token expired or no refresh token
                    return [2 /*return*/, this.generateToken()];
                }
                if (expireIn - 10000 >= Date.now()) {
                    return [2 /*return*/, { refreshToken: refreshToken, accessToken: accessToken }];
                }
                sessionId = +(Math.random() * 1000000000).toFixed();
                return [2 /*return*/, doFetch.doFetch(link, {
                        method: 'post',
                        body: JSON.stringify({ 'refreshToken': Config.get('customer.refreshToken'), 'platform': this.conf.platform }),
                        headers: {
                            'platform': this.conf.platform,
                            'Authorization': 'Bearer ' + accessToken,
                            'Content-Type': 'application/json',
                            'x-session-id': String(sessionId),
                            'x-transaction-id': String(sessionId - 1)
                        },
                        errorFormatter: 'AIS'
                    })
                        .then(function (data) {
                        if (data.statusCode === 200) {
                            //data.result.expiresIn - in minutes
                            var expired = (+data.result.expiresIn * 60 * 1000) + Date.now();
                            updateAMSData({
                                customer: {
                                    accessToken: data.result.accessToken,
                                    refreshToken: data.result.refreshToken,
                                    expireIn: expired
                                }
                            });
                        }
                        else if (data.statusCode === 401) {
                            return _this.generateToken();
                        }
                        else {
                            throw formatAISError.formatAISError(data);
                        }
                        return data.result;
                    })];
            });
        });
    };
    AisMainApi.prototype.accountInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var link, accessToken, sessionId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.refreshToken()];
                    case 1:
                        _a.sent();
                        link = this.formatPath('account');
                        accessToken = Config.get('customer.accessToken');
                        sessionId = +(Math.random() * 1000000000).toFixed();
                        return [2 /*return*/, doFetch.doFetch(link, {
                                method: 'get',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'platform': this.conf.platform,
                                    'Authorization': 'Bearer ' + accessToken,
                                    'x-session-id': String(sessionId),
                                    'x-transaction-id': String(sessionId - 1)
                                },
                                errorFormatter: 'AIS'
                            })
                                .then(function (data) {
                                if (data.statusCode === 200) {
                                    updateAMSData({
                                        customer: {
                                            contactNumber: data.result.contactNumber,
                                            internetNumber: data.result.internetNumber,
                                            networkType: data.result.NetworkType
                                        }
                                    });
                                }
                                else {
                                    throw formatAISError.formatAISError(data);
                                }
                                return data.result;
                            })];
                }
            });
        });
    };
    AisMainApi.prototype.packages = function () {
        var link = this.formatPath('current-package');
        var accessToken = Config.get('customer.accessToken');
        var sessionId = +(Math.random() * 1000000000).toFixed();
        return doFetch.doFetch(link, {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                'platform': this.conf.platform,
                'Authorization': 'Bearer ' + accessToken,
                'x-session-id': String(sessionId),
                'x-transaction-id': String(sessionId - 1)
            },
            errorFormatter: 'AIS'
        })
            .then(function (data) {
            if (data.statusCode === 200) {
                return data.result;
            }
            else {
                throw formatAISError.formatAISError(data);
            }
        });
    };
    AisMainApi.prototype.checkRedemption = function () {
        return __awaiter(this, void 0, void 0, function () {
            var link;
            return __generator(this, function (_a) {
                link = this.formatPath('checkPromo', 'redemption');
                return [2 /*return*/, doFetch.doFetch(link, {
                        method: 'post',
                        body: JSON.stringify({
                            platform: this.conf.platform,
                            udid: this.conf.udid,
                            model: this.conf.model
                        }),
                        headers: {
                            Authorization: this.conf.redemption.token,
                            'Content-Type': String('application/json'),
                            'x-transaction-id': String(+(Math.random() * 1000000000).toFixed())
                        },
                        errorFormatter: 'AIS'
                    })
                        .then(function (data) {
                        // this.$logger('checkRedemption').log(data)
                        if (data.error) {
                            throw formatAISError.formatAISError(data.error);
                        }
                        return data;
                    })];
            });
        });
    };
    AisMainApi.prototype.answerRedemption = function (buttonAction, link) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                link = link || "".concat(this.formatPath('reply', 'redemption'), "?uid=").concat(this.conf.udid, "&option=").concat(buttonAction);
                return [2 /*return*/, doFetch.doFetch(link, {
                        headers: {
                            Authorization: this.conf.redemption.token,
                            'Content-Type': String('application/json'),
                            'x-transaction-id': String(+(Math.random() * 1000000000).toFixed())
                        },
                        errorFormatter: 'AIS'
                    }).then(function (data) {
                        if (data.error) {
                            throw formatAISError.formatAISError(data.error);
                        }
                        return buttonAction;
                    })];
            });
        });
    };
    AisMainApi.prototype.verifyRedemption = function () {
        return __awaiter(this, void 0, void 0, function () {
            var link;
            return __generator(this, function (_a) {
                link = this.formatPath('verifyReceivePromo', 'redemption');
                return [2 /*return*/, doFetch.doFetch(link, {
                        method: 'post',
                        body: JSON.stringify({
                            platform: this.conf.platform,
                            udid: this.conf.udid,
                            model: this.conf.model
                        }),
                        headers: {
                            Authorization: this.conf.redemption.token,
                            'Content-Type': String('application/json'),
                            'x-transaction-id': String(+(Math.random() * 1000000000).toFixed())
                        },
                        errorFormatter: 'AIS'
                    }).then(function (data) {
                        if (data && data.status && data.status.toLowerCase() === 'success') {
                            return true;
                        }
                        else if (data === null || data === void 0 ? void 0 : data.error) {
                            throw formatAISError.formatAISError(data.error);
                        }
                        return false;
                    })];
            });
        });
    };
    return AisMainApi;
}());

var AisAccount = /** @class */ (function (_super) {
    __extends(AisAccount, _super);
    function AisAccount(client) {
        var _this = _super.call(this, client) || this;
        _this.client = client;
        _this.apiV1 = new AisApiV1(_this.client);
        _this.apiV2 = new AisApiV2(_this.client);
        _this.api = new AisMainApi(_this.client);
        return _this;
    }
    AisAccount.prototype.getProductsByItem = function (itemId) {
        return __awaiter(this, void 0, void 0, function () {
            var promises, i;
            return __generator(this, function (_a) {
                if (typeof itemId === 'string') {
                    return [2 /*return*/, this.client.callAms("/get_products/".concat(itemId, "/")).then(function (response) {
                            return response.products;
                        })];
                }
                else if (Array.isArray(itemId)) {
                    promises = [];
                    for (i = 0; i < itemId.length; i++) {
                        promises.push(this.client.callAms("/get_products/".concat(itemId[i], "/"))
                            .then(function (response) {
                            return response.products;
                        })["catch"](function () {
                            return null;
                        }));
                    }
                    return [2 /*return*/, Promise.all(promises)];
                }
                return [2 /*return*/];
            });
        });
    };
    AisAccount.prototype.acceptTerms = function (docVersion) {
        var consentDtypes = Config.get('user.consent_dtypes') ? Config.get('user.consent_dtypes') : [];
        var acceptLink = '';
        if (docVersion) {
            acceptLink = "/accounts/doc/?dtype=".concat(consentDtypes.join(), "&act=agree&version=").concat(docVersion);
        }
        else {
            acceptLink = "/accounts/doc/?dtype=".concat(consentDtypes.join(), "&act=agree");
        }
        return this.client.callAms(acceptLink, { cache: false })
            .then(function (data) {
            var user = Config.get('user');
            user.consent = true;
            updateAMSData({ user: user });
            return data;
        });
    };
    /**
     * for login through ANDROMEDA (AIS)
     * */
    AisAccount.prototype.generateOtp = function (phoneNumber) {
        if (phoneNumber === void 0) { phoneNumber = null; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!phoneNumber) {
                    throw new appError.AppError(errorCodes.ErrorCodes.MISS_PARAMETER, 'The phone number required!', '');
                }
                // todo: does it need to sends fungus_login_attempt/fungus_login_failure/fungus_login_success here?
                return [2 /*return*/, this.client.callAms('/accounts/otp/', {
                        query: { msisdn: phoneNumber },
                        cache: false
                    }).then(function (data) {
                        var _a;
                        if ((_a = data === null || data === void 0 ? void 0 : data.info) === null || _a === void 0 ? void 0 : _a.transactionID) {
                            updateAMSData({
                                customer: {
                                    msisdn: phoneNumber,
                                    transactionID: data.info.transactionID
                                }
                            });
                            return data.info;
                        }
                        else {
                            throw new appError.AppError(errorCodes.ErrorCodes.AMS_ERR, 'transactionID', 'AMS Response does not contain "transactionID"!');
                        }
                    })];
            });
        });
    };
    /**
     * for login through ANDROMEDA (AIS)
     * */
    AisAccount.prototype.loginByOtp = function (otp, options) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var data, error_1, timestamp, idType, credentials, amsData, fungusEventParams, error;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!otp) {
                            throw new appError.AppError(errorCodes.ErrorCodes.MISS_PARAMETER, 'the OTP code required!', '');
                        }
                        if (this.client.analyticsModule) {
                            this.client.analyticsModule.send('fungus_login_attempt');
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.client.callAms('/accounts/otp/', {
                                query: {
                                    msisdn: Config.get('customer.msisdn'),
                                    otp: otp,
                                    trs: Config.get('customer.transactionID')
                                },
                                cache: false
                            })];
                    case 2:
                        data = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        if (this.client.analyticsModule) {
                            this.client.analyticsModule.send('fungus_login_failure', {}, { error: error_1 });
                        }
                        throw error_1;
                    case 4:
                        if (!(data.info && data.info.privateId)) return [3 /*break*/, 9];
                        timestamp = Date.now();
                        idType = data.info.idType === 'E.164' ? '0' : data.info.idType === 'E.164' ? '3' : data.info.idType;
                        credentials = {
                            // accessToken: data.info.accessToken,
                            // expireIn: data.info.expireIn,
                            privateId: data.info.privateId,
                            idValue: data.info.idValue,
                            idType: idType,
                            operatorId: data.info.operatorId
                        };
                        amsData = void 0;
                        fungusEventParams = {};
                        _a.label = 5;
                    case 5:
                        _a.trys.push([5, , 7, 8]);
                        return [4 /*yield*/, this.loginByPrivateId(credentials, __assign({ login_type: 'andromeda' }, options))];
                    case 6:
                        amsData = _a.sent();
                        fungusEventParams = {
                            user_id: amsData.user.id,
                            session_id: amsData.user.sid
                        };
                        return [3 /*break*/, 8];
                    case 7:
                        if (this.client.analyticsModule) {
                            this.client.analyticsModule.send('fungus_login_success', fungusEventParams, { buffer_timestamp: timestamp });
                        }
                        return [7 /*endfinally*/];
                    case 8:
                        // const expired = +data.info.expireIn + Date.now() // expireIn ex: "864000", seems it milliseconds | 864000 / 1000 / 60 / 60 = 14.4 minutes
                        updateAMSData({
                            customer: {
                                idValue: data.info.idValue,
                                idType: data.info.idType,
                                operatorId: data.info.operatorId,
                                xExpireIn: +data.info.expireIn + Date.now(),
                                // xSessionId: fungusData['x-session-id'],
                                xAccessToken: data.info.accessToken,
                                // xPartnerSpecificId: fungusData['x-partner-specific-id'],
                                xApp: 'appName=smarttv; appVersion=1.0.0;'
                                // expireIn: expired,
                                // accessToken: data.info.accessToken
                            }
                        });
                        return [2 /*return*/, amsData];
                    case 9:
                        error = new appError.AppError(errorCodes.ErrorCodes.AMS_ERR, 'Login failure', 'Unknown AMS/Fungus error');
                        if (this.client.analyticsModule) {
                            this.client.analyticsModule.send('fungus_login_failure', {}, { error: error });
                        }
                        throw error;
                }
            });
        });
    };
    AisAccount.prototype.openFungusLoginPage = function (redirectUrl) {
        return this.apiV2.openOl5LoginPage(redirectUrl);
    };
    AisAccount.prototype.loginByFungusOL5Token = function (ol5, redirectUrl, options) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var time, fungusData, amsData, fungusEventParams;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        time = Date.now();
                        return [4 /*yield*/, this.apiV2.loginByOl5(ol5, redirectUrl)];
                    case 1:
                        fungusData = _a.sent();
                        fungusEventParams = {};
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, , 4, 5]);
                        return [4 /*yield*/, this.loginByPrivateId({
                                idValue: fungusData.idValue,
                                idType: fungusData.idType,
                                operatorId: fungusData.operatorId,
                                privateId: fungusData.privateId
                            }, __assign({ login_type: 'fungus' }, options))];
                    case 3:
                        amsData = _a.sent();
                        fungusEventParams = {
                            user_id: amsData.user.id,
                            session_id: amsData.user.sid
                        };
                        return [3 /*break*/, 5];
                    case 4:
                        if (this.client.analyticsModule) {
                            this.client.analyticsModule.send('fungus_login_success', fungusEventParams, { buffer_timestamp: time });
                        }
                        return [7 /*endfinally*/];
                    case 5:
                        updateAMSData({
                            customer: {
                                ol5: ol5,
                                ol4: fungusData.ol4,
                                // headers: fungusData.headers,
                                idValue: fungusData.idValue,
                                idType: fungusData.idType,
                                operatorId: fungusData.operatorId,
                                xExpireIn: +fungusData.expireIn + Date.now(),
                                xSessionId: fungusData.headers['x-session-id'],
                                xAccessToken: fungusData.accessToken,
                                xPartnerSpecificId: fungusData.headers['x-partner-specific-id'],
                                xApp: fungusData.headers['x-app']
                            }
                        });
                        return [2 /*return*/, amsData];
                }
            });
        });
    };
    AisAccount.prototype.loginByB2C = function (options) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var b2cData, timestamp, amsData, fungusEventParams;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiV1.loginByB2C()];
                    case 1:
                        b2cData = _a.sent();
                        timestamp = Date.now();
                        fungusEventParams = {};
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, , 4, 5]);
                        return [4 /*yield*/, this.loginByPrivateId({
                                privateId: b2cData.privateId,
                                idValue: b2cData.idValue,
                                idType: b2cData.idType,
                                operatorId: b2cData.operatorId
                            }, options)];
                    case 3:
                        amsData = _a.sent();
                        fungusEventParams = {
                            user_id: amsData.user.id,
                            session_id: amsData.user.sid
                        };
                        return [3 /*break*/, 5];
                    case 4:
                        /** todo: maybe need to move */
                        if (this.client.analyticsModule) {
                            this.client.analyticsModule.send('fungus_login_success', fungusEventParams, { buffer_timestamp: timestamp });
                        }
                        return [7 /*endfinally*/];
                    case 5:
                        updateAMSData({
                            customer: {
                                idValue: b2cData.idValue,
                                idType: b2cData.idType,
                                operatorId: b2cData.operatorId,
                                xExpireIn: +b2cData.expireIn + Date.now(),
                                xSessionId: b2cData['x-session-id'],
                                xAccessToken: b2cData.accessToken,
                                xPartnerSpecificId: b2cData['x-partner-specific-id'],
                                xApp: b2cData['x-app']
                            }
                        });
                        return [2 /*return*/, amsData];
                }
            });
        });
    };
    /**
     * login into ams with private id (after fungus/andromeda login)
     * */
    AisAccount.prototype.loginByPrivateId = function (credentials, options) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var idType, idValue;
            return __generator(this, function (_a) {
                idType = credentials.idType;
                idValue = credentials.idValue;
                return [2 /*return*/, this.amsLogin(null, null, credentials, __assign(__assign({}, options), { userData: {
                            second_screen: (idType === '3') || (idValue && (idValue.indexOf('88') === 0 || idValue.indexOf('89') === 0)),
                            idType: idType,
                            idValue: idValue
                        } }))];
            });
        });
    };
    AisAccount.prototype.logout = function (isGuest) {
        if (isGuest === void 0) { isGuest = false; }
        return __awaiter(this, void 0, void 0, function () {
            var _a, e_1;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.client.isAuth()) {
                            return [2 /*return*/, true];
                        }
                        if (this.logoutCall) {
                            return [2 /*return*/, new Promise(function (resolve, reject) {
                                    _this.logoutCall.then(function (data) {
                                        resolve(data);
                                        return data;
                                    })["catch"](function (error) {
                                        reject(error);
                                        throw error;
                                    });
                                })];
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 6, , 7]);
                        _a = Config.get('user.login_type');
                        switch (_a) {
                            case 'fungus': return [3 /*break*/, 2];
                            case 'andromeda': return [3 /*break*/, 4];
                        }
                        return [3 /*break*/, 5];
                    case 2: return [4 /*yield*/, this.apiV2.logout()];
                    case 3:
                        _b.sent();
                        return [3 /*break*/, 5];
                    case 4: 
                    // todo
                    return [3 /*break*/, 5];
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        e_1 = _b.sent();
                        console.error(e_1);
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/, _super.prototype.logout.call(this, isGuest)];
                }
            });
        });
    };
    return AisAccount;
}(Account));

var AisAmsClient = /** @class */ (function (_super) {
    __extends(AisAmsClient, _super);
    function AisAmsClient() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.account = new AisAccount(_this);
        return _this;
    }
    return AisAmsClient;
}(AMSClient));

module.exports = AisAmsClient;
